import * as i0 from '@angular/core';
import { signal, computed, Injectable, inject, viewChild, effect, Component, DestroyRef, ViewChild, HostListener, Input, Pipe, ChangeDetectionStrategy, input, EventEmitter, Output, InjectionToken } from '@angular/core';
import * as i2$1 from '@angular/router';
import { ActivatedRoute, RouterModule, Router } from '@angular/router';
import { AvcMapsDisplayService, MapPreset, MapThemePreset, MapOverlayLayer, TopographyState, AvcMapsDisplayModule } from '@garmin-avcloud/avc-maps-display';
import { FLY_WEB_COMMON_CONFIG } from '@garmin-avcloud/avcloud-fly-web-common/config';
import * as i2 from '@garmin-avcloud/avcloud-fly-web-common/shared';
import { ComponentsGlobalWebModule, IconComponent, FormattedDatePipe, FeatureFlyGarmin, FeatureFlyAdmin } from '@garmin-avcloud/avcloud-fly-web-common/shared';
import { AircraftFlightLogService, AircraftFlightLogUploadService } from '@garmin-avcloud/avcloud-web-data-services/aircraft-logbook';
import { AircraftReadService } from '@garmin-avcloud/avcloud-web-data-services/aircraft-management';
import { skip, forkJoin, distinct, Subject, tap, filter, map, switchMap, startWith, pairwise, catchError, interval, of, takeWhile, distinctUntilChanged } from 'rxjs';
import * as i1 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import { toObservable, takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Chart, CategoryScale, Colors, LinearScale, LineController, LineElement, Legend, PointElement, TimeScale, Tooltip } from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import zoomPlugin from 'chartjs-plugin-zoom';
import 'chartjs-adapter-date-fns';
import * as i3 from '@angular/forms';
import { FormControl, ReactiveFormsModule, FormGroup } from '@angular/forms';
import { parseISO, addDays, isBefore, compareDesc } from 'date-fns';
import { FlyGarminLegacyBaseUrl, GARMIN_CDN_URL } from '@garmin-avcloud/avcloud-fly-web-common/_shared';
import { isValidUuid, isStringNonEmpty, LocalStorageService, LocalStorageKey } from '@garmin-avcloud/avcloud-web-utils';
import { FeaturesService } from '@garmin-avcloud/avcloud-web-utils/feature';
import { HttpClient } from '@angular/common/http';
const _c0 = ["range"];
function AircraftFlightLogPlaybackControlsComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function AircraftFlightLogPlaybackControlsComponent_Conditional_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.aircraftFlightLogPlaybackService.play());
    });
    i0.ɵɵelement(1, "fly-icon", 9);
    i0.ɵɵelementEnd();
  }
}
function AircraftFlightLogPlaybackControlsComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵlistener("click", function AircraftFlightLogPlaybackControlsComponent_Conditional_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.aircraftFlightLogPlaybackService.pause());
    });
    i0.ɵɵelement(1, "fly-icon", 11);
    i0.ɵɵelementEnd();
  }
}
const _c1 = ["expandChartWrapper"];
const _c2 = ["chartCanvasWrapper"];
const _c3 = ["chart"];
const _c4 = a0 => ({
  "z-index": a0
});
function LogDetailsChartComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-icon", 8);
  }
}
function LogDetailsChartComponent_For_13_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("selected", ctx_r2.chartDataForm.controls.leftAxis.value === option_r2.fieldName);
    i0.ɵɵattribute("value", option_r2.fieldName);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", option_r2.displayName, " ");
  }
}
function LogDetailsChartComponent_For_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "optgroup", 12);
    i0.ɵɵrepeaterCreate(1, LogDetailsChartComponent_For_13_For_2_Template, 2, 3, "option", 18, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const section_r4 = ctx.$implicit;
    i0.ɵɵproperty("label", section_r4.name);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(section_r4.options);
  }
}
function LogDetailsChartComponent_For_20_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r5 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("selected", ctx_r2.chartDataForm.controls.rightAxis.value === option_r5.fieldName);
    i0.ɵɵattribute("value", option_r5.fieldName);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", option_r5.displayName, " ");
  }
}
function LogDetailsChartComponent_For_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "optgroup", 12);
    i0.ɵɵrepeaterCreate(1, LogDetailsChartComponent_For_20_For_2_Template, 2, 3, "option", 18, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const section_r6 = ctx.$implicit;
    i0.ɵɵproperty("label", section_r6.name);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(section_r6.options);
  }
}
function LogDetailsChartComponent_Conditional_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-icon", 17);
  }
}
const _c5 = ["map"];
function LogDetailsMapComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-icon", 7);
  }
}
function LogDetailsMapComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-icon", 8);
  }
}
const _c6 = ["fullscreenContent"];
function AircraftLogDetailsPlaybackComponent_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "g-skeleton", 2)(1, "g-skeleton", 2)(2, "g-skeleton", 3);
  }
}
function AircraftLogDetailsPlaybackComponent_Case_3_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-icon", 6);
  }
}
function AircraftLogDetailsPlaybackComponent_Case_3_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-icon", 7);
  }
}
function AircraftLogDetailsPlaybackComponent_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelement(0, "aclogbook-log-details-map")(1, "aclogbook-log-details-chart", 1);
    i0.ɵɵelementStart(2, "div", 4);
    i0.ɵɵelement(3, "aclogbook-aircraft-flight-log-playback-controls");
    i0.ɵɵelementStart(4, "button", 5);
    i0.ɵɵlistener("click", function AircraftLogDetailsPlaybackComponent_Case_3_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleFullscreen());
    });
    i0.ɵɵtemplate(5, AircraftLogDetailsPlaybackComponent_Case_3_Conditional_5_Template, 1, 0, "fly-icon", 6)(6, AircraftLogDetailsPlaybackComponent_Case_3_Conditional_6_Template, 1, 0, "fly-icon", 7);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r1.isFullscreen ? "chart-fullscreen" : "chart");
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(!ctx_r1.isFullscreen ? 5 : 6);
  }
}
function AircraftLogDetailsPlaybackComponent_Case_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1, "An error occurred while fetching log data.");
    i0.ɵɵelementEnd();
  }
}
function AircraftLogSummaryComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "flyFormattedDate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind3(2, 1, ctx_r0.aircraftLogDetailsService.flightLog().timeStart, "AbbreviatedDate", "UTC"));
  }
}
function AircraftLogSummaryComponent_Conditional_28_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "number");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_2_0;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind2(2, 1, ctx_r0.aircraftLogDetailsService.flightLog().hobbsTimeStart, (tmp_2_0 = "1.0-1") !== null && tmp_2_0 !== undefined ? tmp_2_0 : "\u2014"), " hrs");
  }
}
function AircraftLogSummaryComponent_Conditional_28_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1, "\u2014");
    i0.ɵɵelementEnd();
  }
}
function AircraftLogSummaryComponent_Conditional_28_Conditional_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "number");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_2_0;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind2(2, 1, ctx_r0.aircraftLogDetailsService.flightLog().hobbsTimeEnd, (tmp_2_0 = "1.0-1") !== null && tmp_2_0 !== undefined ? tmp_2_0 : "\u2014"), " hrs");
  }
}
function AircraftLogSummaryComponent_Conditional_28_Conditional_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1, "\u2014");
    i0.ɵɵelementEnd();
  }
}
function AircraftLogSummaryComponent_Conditional_28_Conditional_18_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1, "Tach");
    i0.ɵɵelementEnd();
  }
}
function AircraftLogSummaryComponent_Conditional_28_Conditional_18_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1, "Tach 1");
    i0.ɵɵelementEnd();
  }
}
function AircraftLogSummaryComponent_Conditional_28_Conditional_18_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1, "\u2014");
    i0.ɵɵelementEnd();
  }
}
function AircraftLogSummaryComponent_Conditional_28_Conditional_18_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "number");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_3_0;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind2(2, 1, ctx_r0.aircraftLogDetailsService.flightLog().tachTime1End, (tmp_3_0 = "1.0-1") !== null && tmp_3_0 !== undefined ? tmp_3_0 : "\u2014"), " hrs");
  }
}
function AircraftLogSummaryComponent_Conditional_28_Conditional_18_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1, "\u2014");
    i0.ɵɵelementEnd();
  }
}
function AircraftLogSummaryComponent_Conditional_28_Conditional_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, AircraftLogSummaryComponent_Conditional_28_Conditional_18_Conditional_1_Template, 2, 0, "span", 8)(2, AircraftLogSummaryComponent_Conditional_28_Conditional_18_Conditional_2_Template, 2, 0, "span", 8);
    i0.ɵɵelement(3, "br");
    i0.ɵɵelementStart(4, "p", 9);
    i0.ɵɵtext(5, "Start");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 5);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "number");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, AircraftLogSummaryComponent_Conditional_28_Conditional_18_Conditional_9_Template, 2, 0, "span", 10);
    i0.ɵɵelement(10, "hr", 11);
    i0.ɵɵelementStart(11, "p", 9);
    i0.ɵɵtext(12, "End");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, AircraftLogSummaryComponent_Conditional_28_Conditional_18_Conditional_13_Template, 3, 4, "span", 5)(14, AircraftLogSummaryComponent_Conditional_28_Conditional_18_Conditional_14_Template, 2, 0, "span", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_3_0;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.aircraftLogDetailsService.flightLog().tachTime2Start ? 1 : 2);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind2(8, 4, ctx_r0.aircraftLogDetailsService.flightLog().tachTime1Start, (tmp_3_0 = "1.0-1") !== null && tmp_3_0 !== undefined ? tmp_3_0 : "\u2014"), " hrs");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.aircraftLogDetailsService.flightLog().tachTime1Start == null ? 9 : -1);
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(ctx_r0.aircraftLogDetailsService.flightLog().tachTime1End != null ? 13 : 14);
  }
}
function AircraftLogSummaryComponent_Conditional_28_Conditional_19_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "number");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_3_0;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind2(2, 1, ctx_r0.aircraftLogDetailsService.flightLog().tachTime2Start, (tmp_3_0 = "1.0-1") !== null && tmp_3_0 !== undefined ? tmp_3_0 : "\u2014"), " hrs");
  }
}
function AircraftLogSummaryComponent_Conditional_28_Conditional_19_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1, "\u2014");
    i0.ɵɵelementEnd();
  }
}
function AircraftLogSummaryComponent_Conditional_28_Conditional_19_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "number");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_3_0;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind2(2, 1, ctx_r0.aircraftLogDetailsService.flightLog().tachTime2End, (tmp_3_0 = "1.0-1") !== null && tmp_3_0 !== undefined ? tmp_3_0 : "\u2014"), " hrs");
  }
}
function AircraftLogSummaryComponent_Conditional_28_Conditional_19_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1, "\u2014");
    i0.ɵɵelementEnd();
  }
}
function AircraftLogSummaryComponent_Conditional_28_Conditional_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "span", 8);
    i0.ɵɵtext(2, "Tach 2");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "br");
    i0.ɵɵelementStart(4, "p", 9);
    i0.ɵɵtext(5, "Start");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, AircraftLogSummaryComponent_Conditional_28_Conditional_19_Conditional_6_Template, 3, 4, "span", 5)(7, AircraftLogSummaryComponent_Conditional_28_Conditional_19_Conditional_7_Template, 2, 0, "span", 10);
    i0.ɵɵelement(8, "hr", 11);
    i0.ɵɵelementStart(9, "p", 9);
    i0.ɵɵtext(10, "End");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, AircraftLogSummaryComponent_Conditional_28_Conditional_19_Conditional_11_Template, 3, 4, "span", 5)(12, AircraftLogSummaryComponent_Conditional_28_Conditional_19_Conditional_12_Template, 2, 0, "span", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(6);
    i0.ɵɵconditional(ctx_r0.aircraftLogDetailsService.flightLog().tachTime2Start != null ? 6 : 7);
    i0.ɵɵadvance(5);
    i0.ɵɵconditional(ctx_r0.aircraftLogDetailsService.flightLog().tachTime2End != null ? 11 : 12);
  }
}
function AircraftLogSummaryComponent_Conditional_28_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "hr", 6);
    i0.ɵɵelementStart(1, "div", 7)(2, "h3");
    i0.ɵɵtext(3, "ENGINE TIME");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 2)(5, "div", 3)(6, "span", 8);
    i0.ɵɵtext(7, "Hobbs");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "br");
    i0.ɵɵelementStart(9, "p", 9);
    i0.ɵɵtext(10, "Start");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, AircraftLogSummaryComponent_Conditional_28_Conditional_11_Template, 3, 4, "span", 5)(12, AircraftLogSummaryComponent_Conditional_28_Conditional_12_Template, 2, 0, "span", 10);
    i0.ɵɵelement(13, "hr", 11);
    i0.ɵɵelementStart(14, "p", 9);
    i0.ɵɵtext(15, "End");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(16, AircraftLogSummaryComponent_Conditional_28_Conditional_16_Template, 3, 4, "span", 5)(17, AircraftLogSummaryComponent_Conditional_28_Conditional_17_Template, 2, 0, "span", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(18, AircraftLogSummaryComponent_Conditional_28_Conditional_18_Template, 15, 7, "div", 3)(19, AircraftLogSummaryComponent_Conditional_28_Conditional_19_Template, 13, 2, "div", 3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(11);
    i0.ɵɵconditional(ctx_r0.aircraftLogDetailsService.flightLog().hobbsTimeStart != null ? 11 : 12);
    i0.ɵɵadvance(5);
    i0.ɵɵconditional(ctx_r0.aircraftLogDetailsService.flightLog().hobbsTimeEnd != null ? 16 : 17);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.aircraftLogDetailsService.flightLog().tachTime1Start ? 18 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.aircraftLogDetailsService.flightLog().tachTime2Start ? 19 : -1);
  }
}
const _c7 = a0 => ["/aircraft-logbook/", a0];
const _c8 = () => ["/aircraft-logbook/"];
function AircraftLogDetailsComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "g-loader", 0);
  }
}
function AircraftLogDetailsComponent_Conditional_1_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 4);
    i0.ɵɵtext(1, "Aircraft Logbook");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(1, _c8));
  }
}
function AircraftLogDetailsComponent_Conditional_1_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " Aircraft Logbook ");
  }
}
function AircraftLogDetailsComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "div")(2, "h1");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "flyFormattedDate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 2)(6, "g-breadcrumbs")(7, "nav", 3)(8, "g-breadcrumb");
    i0.ɵɵtemplate(9, AircraftLogDetailsComponent_Conditional_1_Conditional_9_Template, 2, 2, "a", 4)(10, AircraftLogDetailsComponent_Conditional_1_Conditional_10_Template, 1, 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "g-breadcrumb")(12, "a", 4);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(14, "g-breadcrumb", 5);
    i0.ɵɵpipe(15, "flyFormattedDate");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(16, "div", 6)(17, "g-button", 7);
    i0.ɵɵlistener("click", function AircraftLogDetailsComponent_Conditional_1_Template_g_button_click_17_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.downloadLogAsCsv());
    });
    i0.ɵɵtext(18, " Download Log ");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(19, "div", 8);
    i0.ɵɵelement(20, "aclogbook-aircraft-log-summary", 9);
    i0.ɵɵelementStart(21, "div", 10)(22, "g-button", 11);
    i0.ɵɵlistener("click", function AircraftLogDetailsComponent_Conditional_1_Template_g_button_click_22_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.downloadLogAsCsv());
    });
    i0.ɵɵtext(23, " Download Log ");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(24, "aclogbook-aircraft-log-details-playback", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" Flight Log - ", i0.ɵɵpipeBind3(4, 6, ctx_r1.aircraftLogDetailsService.flightLog().timeStart, "AbbreviatedDate", "UTC"), " ");
    i0.ɵɵadvance(6);
    i0.ɵɵconditional(ctx_r1.showLogbookUrl ? 9 : 10);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(14, _c7, ctx_r1.aircraftLogDetailsService.aircraft().aircraftUuid));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r1.aircraftLogDetailsService.aircraft().tailNumber, " Flight Logs");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("text", i0.ɵɵpipeBind3(15, 10, ctx_r1.aircraftLogDetailsService.flightLog().timeStart, "AbbreviatedDate", "UTC"));
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("logbookEntryUuid", ctx_r1.logbookEntryUuid);
  }
}
function AircraftLogDetailsComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1, "There was an issue trying to load information for this log entry.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "p");
    i0.ɵɵtext(3, "Please try again or contact support.");
    i0.ɵɵelementEnd();
  }
}
const _c9 = ["aclogbook-log-row", ""];
function LogRowComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 1);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "flyFormattedDate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td", 2);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "flyFormattedDate");
    i0.ɵɵelement(6, "br");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "aclogbookFormattedFlightLogResponseStartTime");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind3(2, 3, ctx_r0.logRow.timeStart, "AbbreviatedDate", "UTC"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(5, 7, ctx_r0.logRow.timeStart, "AbbreviatedDate", "UTC"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 11, ctx_r0.logRow), " ");
  }
}
function LogRowComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "aclogbookFormattedFlightLogResponseStartTime");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r0.logRow));
  }
}
function LogRowComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "aclogbookFormattedFlightLogResponseDuration");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r0.logRow));
  }
}
function LogRowComponent_Conditional_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1, "\u2014");
    i0.ɵɵelementEnd();
  }
}
function LogRowComponent_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "number");
    i0.ɵɵelement(3, "br");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "number");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_2_0;
    let tmp_3_0;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" Start: ", i0.ɵɵpipeBind2(2, 2, ctx_r0.logRow.hobbsTimeStart, (tmp_2_0 = "1.0-1") !== null && tmp_2_0 !== undefined ? tmp_2_0 : "\u2014"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("End: ", i0.ɵɵpipeBind2(5, 5, ctx_r0.logRow.hobbsTimeEnd, (tmp_3_0 = "1.0-1") !== null && tmp_3_0 !== undefined ? tmp_3_0 : "\u2014"), " ");
  }
}
function LogRowComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, LogRowComponent_Conditional_3_Conditional_0_Template, 2, 0, "td")(1, LogRowComponent_Conditional_3_Conditional_1_Template, 6, 8, "td");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.logRow.hobbsTimeStart == null && ctx_r0.logRow.hobbsTimeEnd == null ? 0 : 1);
  }
}
function LogRowComponent_Conditional_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 3);
    i0.ɵɵtext(1, "\u2014");
    i0.ɵɵelementEnd();
  }
}
function LogRowComponent_Conditional_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 3);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "number");
    i0.ɵɵelement(3, "br");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "number");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_2_0;
    let tmp_3_0;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" Start: ", i0.ɵɵpipeBind2(2, 2, ctx_r0.logRow.tachTime1Start, (tmp_2_0 = "1.0-1") !== null && tmp_2_0 !== undefined ? tmp_2_0 : "\u2014"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("End: ", i0.ɵɵpipeBind2(5, 5, ctx_r0.logRow.tachTime1End, (tmp_3_0 = "1.0-1") !== null && tmp_3_0 !== undefined ? tmp_3_0 : "\u2014"), " ");
  }
}
function LogRowComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, LogRowComponent_Conditional_4_Conditional_0_Template, 2, 0, "td", 3)(1, LogRowComponent_Conditional_4_Conditional_1_Template, 6, 8, "td", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.logRow.tachTime1Start == null && ctx_r0.logRow.tachTime1End == null ? 0 : 1);
  }
}
function LogRowComponent_Conditional_5_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 3);
    i0.ɵɵtext(1, "\u2014");
    i0.ɵɵelementEnd();
  }
}
function LogRowComponent_Conditional_5_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 3);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "number");
    i0.ɵɵelement(3, "br");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "number");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_2_0;
    let tmp_3_0;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" Start: ", i0.ɵɵpipeBind2(2, 2, ctx_r0.logRow.tachTime1Start, (tmp_2_0 = "1.0-1") !== null && tmp_2_0 !== undefined ? tmp_2_0 : "\u2014"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("End: ", i0.ɵɵpipeBind2(5, 5, ctx_r0.logRow.tachTime1End, (tmp_3_0 = "1.0-1") !== null && tmp_3_0 !== undefined ? tmp_3_0 : "\u2014"), " ");
  }
}
function LogRowComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, LogRowComponent_Conditional_5_Conditional_0_Template, 2, 0, "td", 3)(1, LogRowComponent_Conditional_5_Conditional_1_Template, 6, 8, "td", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.logRow.tachTime1Start == null && ctx_r0.logRow.tachTime1End == null ? 0 : 1);
  }
}
function LogRowComponent_Conditional_6_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 3);
    i0.ɵɵtext(1, "\u2014");
    i0.ɵɵelementEnd();
  }
}
function LogRowComponent_Conditional_6_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 3);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "number");
    i0.ɵɵelement(3, "br");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "number");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_2_0;
    let tmp_3_0;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" Start: ", i0.ɵɵpipeBind2(2, 2, ctx_r0.logRow.tachTime2Start, (tmp_2_0 = "1.0-1") !== null && tmp_2_0 !== undefined ? tmp_2_0 : "\u2014"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("End: ", i0.ɵɵpipeBind2(5, 5, ctx_r0.logRow.tachTime2End, (tmp_3_0 = "1.0-1") !== null && tmp_3_0 !== undefined ? tmp_3_0 : "\u2014"), " ");
  }
}
function LogRowComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, LogRowComponent_Conditional_6_Conditional_0_Template, 2, 0, "td", 3)(1, LogRowComponent_Conditional_6_Conditional_1_Template, 6, 8, "td", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.logRow.tachTime2Start == null && ctx_r0.logRow.tachTime2End == null ? 0 : 1);
  }
}
function LogRowComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td")(1, "a", 4);
    i0.ɵɵlistener("click", function LogRowComponent_Conditional_7_Template_a_click_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.downloadLogAsCsv($event));
    });
    i0.ɵɵelement(2, "fly-icon", 5);
    i0.ɵɵelementEnd()();
  }
}
const _c10 = (a0, a1) => ({
  "tach-header": a0,
  download: a1
});
const _c11 = a0 => ["entry", a0];
const _c12 = a0 => ({
  download: a0
});
function LogTableComponent_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const header_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c10, header_r1 === ctx_r1.LogTableHeaders.TACH || header_r1 === ctx_r1.LogTableHeaders.TACH1 || header_r1 === ctx_r1.LogTableHeaders.TACH2, header_r1 === ctx_r1.LogTableHeaders.DOWNLOAD));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", header_r1, " ");
  }
}
function LogTableComponent_For_7_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tr", 3);
  }
  if (rf & 2) {
    const logRow_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(5, _c11, logRow_r3.id))("logRow", logRow_r3)("headers", ctx_r1.desktopHeaders())("flightLogId", logRow_r3.id)("tailNumber", ctx_r1.tailNumber);
  }
}
function LogTableComponent_For_7_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tr", 4);
  }
  if (rf & 2) {
    const logRow_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("logRow", logRow_r3)("headers", ctx_r1.desktopHeaders())("flightLogId", logRow_r3.id)("tailNumber", ctx_r1.tailNumber);
  }
}
function LogTableComponent_For_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, LogTableComponent_For_7_Conditional_0_Template, 1, 7, "tr", 3)(1, LogTableComponent_For_7_Conditional_1_Template, 1, 4, "tr", 4);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.entryDetailsEnabled ? 0 : 1);
  }
}
function LogTableComponent_For_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const header_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c12, header_r4 === ctx_r1.LogTableHeaders.DOWNLOAD));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", header_r4, " ");
  }
}
function LogTableComponent_For_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tr", 3);
  }
  if (rf & 2) {
    const logRow_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(5, _c11, logRow_r5.id))("logRow", logRow_r5)("headers", ctx_r1.mobileHeaders)("flightLogId", logRow_r5.id)("tailNumber", ctx_r1.tailNumber);
  }
}
const _c13 = () => ["/aviation-support"];
const _c14 = () => ["/aircraft-logbook/upload"];
function AircraftLogbookEntriesComponent_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h1");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r0.aircraft.sanitizedTailNumber, " Flight Logs");
  }
}
function AircraftLogbookEntriesComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, AircraftLogbookEntriesComponent_Conditional_0_Conditional_0_Template, 2, 1, "h1");
    i0.ɵɵelementStart(1, "div", 2)(2, "p");
    i0.ɵɵtext(3, "An error occurred while loading information for this aircraft.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p");
    i0.ɵɵtext(5, " Please refresh this page and try again or contact ");
    i0.ɵɵelementStart(6, "a", 3);
    i0.ɵɵtext(7, "Aviation Product Support");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(8, ". ");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.aircraft != null ? 0 : -1);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(2, _c13));
  }
}
function AircraftLogbookEntriesComponent_Conditional_1_Case_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "g-loader", 4);
  }
}
function AircraftLogbookEntriesComponent_Conditional_1_Case_1_Conditional_0_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 3);
    i0.ɵɵtext(1, "Aircraft Logbook");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(1, _c8));
  }
}
function AircraftLogbookEntriesComponent_Conditional_1_Case_1_Conditional_0_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " Aircraft Logbook ");
  }
}
function AircraftLogbookEntriesComponent_Conditional_1_Case_1_Conditional_0_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function AircraftLogbookEntriesComponent_Conditional_1_Case_1_Conditional_0_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "g-loader", 11);
  }
}
function AircraftLogbookEntriesComponent_Conditional_1_Case_1_Conditional_0_Conditional_11_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function AircraftLogbookEntriesComponent_Conditional_1_Case_1_Conditional_0_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, AircraftLogbookEntriesComponent_Conditional_1_Case_1_Conditional_0_Conditional_11_ng_container_0_Template, 1, 0, "ng-container", 10);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(4);
    const tableDisplay_r2 = i0.ɵɵreference(5);
    i0.ɵɵproperty("ngTemplateOutlet", tableDisplay_r2);
  }
}
function AircraftLogbookEntriesComponent_Conditional_1_Case_1_Conditional_0_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "hr", 13);
    i0.ɵɵelementStart(1, "div", 14)(2, "span", 15);
    i0.ɵɵtext(3, "NO FLIGHT LOGS FOUND");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 16)(5, "div", 17);
    i0.ɵɵelement(6, "fly-icon", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 19)(8, "a", 20)(9, "span");
    i0.ɵɵtext(10, "Missing a flight or a partial flight?");
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵelement(11, "hr")(12, "aclogbook-marketing");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("href", ctx_r0.faqUrl, i0.ɵɵsanitizeUrl);
  }
}
function AircraftLogbookEntriesComponent_Conditional_1_Case_1_Conditional_0_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "g-alert", 21);
    i0.ɵɵlistener("g-close", function AircraftLogbookEntriesComponent_Conditional_1_Case_1_Conditional_0_Conditional_13_Template_g_alert_g_close_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.newEntryDetected = false);
    });
    i0.ɵɵtext(1, " A new logbook entry has been added. Return to page 1 to view it. ");
    i0.ɵɵelementEnd();
  }
}
function AircraftLogbookEntriesComponent_Conditional_1_Case_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h1");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 5)(3, "g-breadcrumbs", 6)(4, "nav", 7)(5, "g-breadcrumb", 8);
    i0.ɵɵtemplate(6, AircraftLogbookEntriesComponent_Conditional_1_Case_1_Conditional_0_Conditional_6_Template, 2, 2, "a", 3)(7, AircraftLogbookEntriesComponent_Conditional_1_Case_1_Conditional_0_Conditional_7_Template, 1, 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "g-breadcrumb", 9);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(9, AircraftLogbookEntriesComponent_Conditional_1_Case_1_Conditional_0_ng_container_9_Template, 1, 0, "ng-container", 10)(10, AircraftLogbookEntriesComponent_Conditional_1_Case_1_Conditional_0_Conditional_10_Template, 1, 0, "g-loader", 11)(11, AircraftLogbookEntriesComponent_Conditional_1_Case_1_Conditional_0_Conditional_11_Template, 1, 1, "ng-container")(12, AircraftLogbookEntriesComponent_Conditional_1_Case_1_Conditional_0_Conditional_12_Template, 13, 1)(13, AircraftLogbookEntriesComponent_Conditional_1_Case_1_Conditional_0_Conditional_13_Template, 2, 0, "g-alert", 12);
  }
  if (rf & 2) {
    let tmp_9_0;
    const ctx_r0 = i0.ɵɵnextContext(3);
    const tableForm_r4 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r0.aircraft.sanitizedTailNumber, " Flight Logs");
    i0.ɵɵadvance(5);
    i0.ɵɵconditional(ctx_r0.showLogbookUrl ? 6 : 7);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("text", "", ctx_r0.aircraft.tailNumber, " Flight Logs");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", tableForm_r4);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.pagingService.isLoading() ? 10 : ((tmp_9_0 = ctx_r0.pagingService.currentPage()) == null ? null : tmp_9_0.page == null ? null : tmp_9_0.page.content == null ? null : tmp_9_0.page.content.length) !== 0 ? 11 : 12);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r0.newEntryDetected ? 13 : -1);
  }
}
function AircraftLogbookEntriesComponent_Conditional_1_Case_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, AircraftLogbookEntriesComponent_Conditional_1_Case_1_Conditional_0_Template, 14, 7);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r0.aircraft != null ? 0 : -1);
  }
}
function AircraftLogbookEntriesComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, AircraftLogbookEntriesComponent_Conditional_1_Case_0_Template, 1, 0, "g-loader", 4)(1, AircraftLogbookEntriesComponent_Conditional_1_Case_1_Template, 1, 1);
  }
  if (rf & 2) {
    let tmp_3_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional((tmp_3_0 = ctx_r0.currentState()) === "LOADING" ? 0 : tmp_3_0 === "LOADED" ? 1 : -1);
  }
}
function AircraftLogbookEntriesComponent_ng_template_2_For_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r5 = ctx.$implicit;
    i0.ɵɵproperty("value", option_r5);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", option_r5, " ");
  }
}
function AircraftLogbookEntriesComponent_ng_template_2_Conditional_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "a", 3)(2, "g-button");
    i0.ɵɵtext(3, "UPLOAD LOG");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(1, _c14));
  }
}
function AircraftLogbookEntriesComponent_ng_template_2_Conditional_23_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "g-button", 38);
    i0.ɵɵlistener("click", function AircraftLogbookEntriesComponent_ng_template_2_Conditional_23_Template_g_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.sharingLogPage());
    });
    i0.ɵɵtext(1, " SHARE FLIGHT Logs ");
    i0.ɵɵelementEnd();
  }
}
function AircraftLogbookEntriesComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22)(1, "g-drop-down", 23)(2, "select", 24)(3, "option", 25);
    i0.ɵɵtext(4, " Newest to Oldest ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "option", 26);
    i0.ɵɵtext(6, " Oldest to Newest ");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(7, "g-drop-down", 27)(8, "select", 24);
    i0.ɵɵrepeaterCreate(9, AircraftLogbookEntriesComponent_ng_template_2_For_10_Template, 2, 2, "option", 28, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "div", 29)(12, "g-input", 30);
    i0.ɵɵelement(13, "input", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "g-error", 32);
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "div", 29)(17, "g-input", 33);
    i0.ɵɵelement(18, "input", 34);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "g-error", 35);
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(21, "div", 36);
    i0.ɵɵtemplate(22, AircraftLogbookEntriesComponent_ng_template_2_Conditional_22_Template, 4, 2, "div")(23, AircraftLogbookEntriesComponent_ng_template_2_Conditional_23_Template, 2, 0, "g-button", 37);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formControl", ctx_r0.formGroup.controls.sortOrderControl);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("formControl", ctx_r0.formGroup.controls.entriesPerPageControl);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r0.flightsPerPageOptions);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("error", ctx_r0.formGroup.controls.startDate.errors != null);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControl", ctx_r0.formGroup.controls.startDate);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((ctx_r0.formGroup.errors == null ? null : ctx_r0.formGroup.errors["invalidDateRange"]) != null ? "Start date must be before end date" : "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("error", ctx_r0.formGroup.controls.endDate.errors != null);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControl", ctx_r0.formGroup.controls.endDate);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((ctx_r0.formGroup.errors == null ? null : ctx_r0.formGroup.errors["invalidDateRange"]) != null ? "End date must be after start date" : "");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.uploadLogsEnabled ? 22 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.shareLogsEnabled ? 23 : -1);
  }
}
function AircraftLogbookEntriesComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 39)(1, "div", 17);
    i0.ɵɵelement(2, "fly-icon", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 19)(4, "a", 20)(5, "span");
    i0.ɵɵtext(6, "Missing a flight or a partial flight?");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelement(7, "aclogbook-log-table", 40);
    i0.ɵɵelementStart(8, "div", 41)(9, "span", 42);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "g-pagination", 43);
    i0.ɵɵlistener("g-page-changed", function AircraftLogbookEntriesComponent_ng_template_4_Template_g_pagination_g_page_changed_11_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.updatePage($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("href", ctx_r0.faqUrl, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("page", ctx_r0.pagingService.currentPage())("tailNumber", ctx_r0.aircraft.tailNumber);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate3(" Showing ", ctx_r0.numberOfFirstFlightOnPage(), "-", ctx_r0.numberOfLastFlightOnPage(), " of ", ctx_r0.totalNumberOfFlights(), " Flights ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("currentPage", ctx_r0.currentPage());
    i0.ɵɵpropertyInterpolate("totalPages", ctx_r0.numberOfPages());
  }
}
function SelectFilesComponent_Conditional_12_For_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "span", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 12);
    i0.ɵɵlistener("click", function SelectFilesComponent_Conditional_12_For_5_Template_button_click_3_listener() {
      const file_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r4 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r4.fileUploaderService.deleteFile(ctx_r4.fileUploaderService.selectedFiles().indexOf(file_r4)));
    });
    i0.ɵɵelement(4, "fly-icon", 13);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const file_r4 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(file_r4.name);
  }
}
function SelectFilesComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 9)(2, "strong");
    i0.ɵɵtext(3, "Selected Files:");
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(4, SelectFilesComponent_Conditional_12_For_5_Template, 5, 1, "div", 10, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵrepeater(ctx_r4.fileUploaderService.selectedFiles());
  }
}
function FileUploaderComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 3);
    i0.ɵɵtext(1, "Add at least one log to upload");
    i0.ɵɵelementEnd();
  }
}
const _c15 = () => ["/aircraft-logbook"];
function AircraftLogbookUploadFlyGarminComponent_Conditional_0_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "p", 4);
    i0.ɵɵtext(2, " An error occurred while uploading your files. Please try again or contact ");
    i0.ɵɵelementStart(3, "a", 5);
    i0.ɵɵtext(4, "Aviation Product Support");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(5, " if issues continue. ");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(1, _c13));
  }
}
function AircraftLogbookUploadFlyGarminComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "h1");
    i0.ɵɵtext(1, "UPLOAD AIRCRAFT FLIGHT LOGS");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "p");
    i0.ɵɵtext(3, " This page is used to upload encrypted Aircraft Flight Logs for your aircraft. These logs are automatically uploaded in most cases. For \u201CX.3\u201D display(s), you may upload the log file here and retrieve from the individual aircraft Flight Log page. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "br");
    i0.ɵɵelementStart(5, "p");
    i0.ɵɵtext(6, " If you have any other avionics or are looking to upload a pilot logbook entry, visit the ");
    i0.ɵɵelementStart(7, "a", 1);
    i0.ɵɵtext(8, "Pilot Logbook page");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(9, ". ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "aclogbook-file-uploader", 2);
    i0.ɵɵlistener("filesUploaded", function AircraftLogbookUploadFlyGarminComponent_Conditional_0_Template_aclogbook_file_uploader_filesUploaded_10_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.uploadFiles($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, AircraftLogbookUploadFlyGarminComponent_Conditional_0_Conditional_11_Template, 6, 2, "div", 3);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("href", ctx_r1.pilotLogbookUrl, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(ctx_r1.failedUpload ? 11 : -1);
  }
}
function AircraftLogbookUploadFlyGarminComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵelement(1, "fly-icon", 6);
    i0.ɵɵelementStart(2, "h1");
    i0.ɵɵtext(3, "Your flight logs are being processed");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 7)(5, "p");
    i0.ɵɵtext(6, "This typically takes less than a few minutes.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "p");
    i0.ɵɵtext(8, " Once the logs have finished processing, they will be viewable on the ");
    i0.ɵɵelementStart(9, "a", 5);
    i0.ɵɵtext(10, "Aircraft Flight Log");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(11, " page for you aircraft. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "p");
    i0.ɵɵtext(13, " If you do not see your log on your aircraft within 2 hours, please contact ");
    i0.ɵɵelementStart(14, "a", 5);
    i0.ɵɵtext(15, "Aviation Product Support");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(16, ". ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "p", 8);
    i0.ɵɵtext(18, "You may leave this page and processing will continue in the background.");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(19, "div", 9)(20, "a", 5)(21, "g-button", 10);
    i0.ɵɵtext(22, " AIRCRAFT FLIGHT LOGS ");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(3, _c15));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(4, _c13));
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(5, _c15));
  }
}
const _forTrack0 = ($index, $item) => $item.uploadUuid;
function AircraftLogbookUploadFlyAdminComponent_Conditional_13_For_11_Case_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 2)(1, "a", 5);
    i0.ɵɵlistener("click", function AircraftLogbookUploadFlyAdminComponent_Conditional_13_For_11_Case_5_Template_a_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const log_r2 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.downloadLog(log_r2));
    });
    i0.ɵɵelement(2, "fly-icon", 6);
    i0.ɵɵelementEnd()();
  }
}
function AircraftLogbookUploadFlyAdminComponent_Conditional_13_For_11_Case_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const log_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(log_r2.status);
  }
}
function AircraftLogbookUploadFlyAdminComponent_Conditional_13_For_11_Case_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const log_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(log_r2.status);
  }
}
function AircraftLogbookUploadFlyAdminComponent_Conditional_13_For_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, AircraftLogbookUploadFlyAdminComponent_Conditional_13_For_11_Case_5_Template, 3, 0, "td", 2)(6, AircraftLogbookUploadFlyAdminComponent_Conditional_13_For_11_Case_6_Template, 2, 1, "td", 2)(7, AircraftLogbookUploadFlyAdminComponent_Conditional_13_For_11_Case_7_Template, 2, 1, "td", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_13_0;
    const log_r2 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(log_r2.fileName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(log_r2.uploadUuid);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_13_0 = log_r2.status) === "COMPLETED" ? 5 : tmp_13_0 === "PROCESSING" ? 6 : 7);
  }
}
function AircraftLogbookUploadFlyAdminComponent_Conditional_13_For_21_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 2)(1, "a", 5);
    i0.ɵɵlistener("click", function AircraftLogbookUploadFlyAdminComponent_Conditional_13_For_21_Case_3_Template_a_click_1_listener() {
      i0.ɵɵrestoreView(_r4);
      const log_r5 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.downloadLog(log_r5));
    });
    i0.ɵɵelement(2, "fly-icon", 6);
    i0.ɵɵelementEnd()();
  }
}
function AircraftLogbookUploadFlyAdminComponent_Conditional_13_For_21_Case_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const log_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(log_r5.status);
  }
}
function AircraftLogbookUploadFlyAdminComponent_Conditional_13_For_21_Case_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const log_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(log_r5.status);
  }
}
function AircraftLogbookUploadFlyAdminComponent_Conditional_13_For_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, AircraftLogbookUploadFlyAdminComponent_Conditional_13_For_21_Case_3_Template, 3, 0, "td", 2)(4, AircraftLogbookUploadFlyAdminComponent_Conditional_13_For_21_Case_4_Template, 2, 1, "td", 2)(5, AircraftLogbookUploadFlyAdminComponent_Conditional_13_For_21_Case_5_Template, 2, 1, "td", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_12_0;
    const log_r5 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(log_r5.fileName);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_12_0 = log_r5.status) === "COMPLETED" ? 3 : tmp_12_0 === "PROCESSING" ? 4 : 5);
  }
}
function AircraftLogbookUploadFlyAdminComponent_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 1)(1, "thead")(2, "tr")(3, "th");
    i0.ɵɵtext(4, "FileName");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th");
    i0.ɵɵtext(6, "Upload UUID");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "th", 2);
    i0.ɵɵtext(8, "Status");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(9, "tbody");
    i0.ɵɵrepeaterCreate(10, AircraftLogbookUploadFlyAdminComponent_Conditional_13_For_11_Template, 8, 3, "tr", null, _forTrack0);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "table", 3)(13, "thead")(14, "tr")(15, "th");
    i0.ɵɵtext(16, "FileName");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "th", 2);
    i0.ɵɵtext(18, "Status");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(19, "tbody");
    i0.ɵɵrepeaterCreate(20, AircraftLogbookUploadFlyAdminComponent_Conditional_13_For_21_Template, 6, 2, "tr", null, _forTrack0);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(10);
    i0.ɵɵrepeater(ctx_r2.uploadedLogs);
    i0.ɵɵadvance(10);
    i0.ɵɵrepeater(ctx_r2.uploadedLogs);
  }
}
function AircraftLogbookUploadFlyAdminComponent_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "There are currently no flight logs to decrypt.");
    i0.ɵɵelementEnd();
  }
}
function LogbookAircraftCardComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.aircraft.tailNumber);
  }
}
function LogbookAircraftCardComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "p", 10);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.aircraft.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.aircraft.tailNumber);
  }
}
function LogbookAircraftCardComponent_ng_template_9_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1, "0 flight logs available");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "a", 11)(3, "g-button", 12);
    i0.ɵɵtext(4, " Missing Flight Logs? ");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("href", ctx_r0.faqUrl, i0.ɵɵsanitizeUrl);
  }
}
function LogbookAircraftCardComponent_ng_template_9_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1, "Aircraft is not eligible");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "a", 11)(3, "g-button", 12);
    i0.ɵɵtext(4, " Learn More ");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("href", ctx_r0.learnMoreUrl, i0.ɵɵsanitizeUrl);
  }
}
function LogbookAircraftCardComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, LogbookAircraftCardComponent_ng_template_9_Conditional_0_Template, 5, 1);
    i0.ɵɵpipe(1, "aclogbookSupportsAircraftLogbook");
    i0.ɵɵtemplate(2, LogbookAircraftCardComponent_ng_template_9_Conditional_2_Template, 5, 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(i0.ɵɵpipeBind1(1, 1, ctx_r0.aircraft) ? 0 : 2);
  }
}
function LogbookAircraftCardComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1, "1 flight log available");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "a", 13)(3, "g-button", 14);
    i0.ɵɵtext(4, " View Flight Log ");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(1, _c7, ctx_r0.aircraft.aircraftUuid));
  }
}
function LogbookAircraftCardComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "a", 13)(3, "g-button", 14);
    i0.ɵɵtext(4, " View Flight Logs ");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r0.numberOfElements, " flight logs available");
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(2, _c7, ctx_r0.aircraft.aircraftUuid));
  }
}
function LogbookAircraftListItemComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.aircraft.tailNumber);
  }
}
function LogbookAircraftListItemComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", ctx_r0.aircraft.tailNumber, " (", ctx_r0.aircraft.name, ")");
  }
}
function LogbookAircraftListItemComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "a", 5)(3, "g-button", 6);
    i0.ɵɵtext(4, " View Flight Logs ");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r0.numberOfElements, " flight logs available");
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(2, _c7, ctx_r0.aircraft.aircraftUuid));
  }
}
function LogbookAircraftListItemComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "a", 7)(3, "g-button", 8);
    i0.ɵɵtext(4, " Missing Flight Logs? ");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r0.numberOfElements, " flight logs available");
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", ctx_r0.faqUrl, i0.ɵɵsanitizeUrl);
  }
}
function LogbookAircraftListItemComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1, "Aircraft is not eligible");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "a", 7)(3, "g-button", 8);
    i0.ɵɵtext(4, " Learn More ");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("href", ctx_r0.learnMoreUrl, i0.ɵɵsanitizeUrl);
  }
}
const _c16 = a0 => ({
  active: a0
});
function LogbookAircraftComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h1");
    i0.ɵɵtext(1, "No Aircraft Found");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "hr")(3, "aclogbook-marketing");
  }
}
function LogbookAircraftComponent_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "g-loader", 1);
  }
}
function LogbookAircraftComponent_Conditional_2_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵtext(1, "NO FLIGHT LOGS FOUND");
    i0.ɵɵelementEnd();
  }
}
function LogbookAircraftComponent_Conditional_2_Conditional_4_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "g-drop-down", 6)(1, "select", 21)(2, "option");
    i0.ɵɵtext(3, "10");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "option");
    i0.ɵɵtext(5, "20");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "option");
    i0.ɵɵtext(7, "30");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "option");
    i0.ɵɵtext(9, "40");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "option");
    i0.ɵɵtext(11, "50");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControl", ctx_r1.aircraftPerPageControl);
  }
}
function LogbookAircraftComponent_Conditional_2_Conditional_4_Conditional_0_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "a", 22)(2, "g-button");
    i0.ɵɵtext(3, "UPLOAD LOG");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(1, _c14));
  }
}
function LogbookAircraftComponent_Conditional_2_Conditional_4_Conditional_0_Conditional_12_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "aclogbook-logbook-aircraft-card", 18);
  }
  if (rf & 2) {
    const aircraft_r3 = ctx.$implicit;
    i0.ɵɵproperty("aircraft", aircraft_r3);
  }
}
function LogbookAircraftComponent_Conditional_2_Conditional_4_Conditional_0_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵrepeaterCreate(1, LogbookAircraftComponent_Conditional_2_Conditional_4_Conditional_0_Conditional_12_For_2_Template, 1, 1, "aclogbook-logbook-aircraft-card", 18, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.logbookPagingService.currentPage());
  }
}
function LogbookAircraftComponent_Conditional_2_Conditional_4_Conditional_0_Conditional_13_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "aclogbook-logbook-aircraft-list-item", 18);
  }
  if (rf & 2) {
    const aircraft_r4 = ctx.$implicit;
    i0.ɵɵproperty("aircraft", aircraft_r4);
  }
}
function LogbookAircraftComponent_Conditional_2_Conditional_4_Conditional_0_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵrepeaterCreate(1, LogbookAircraftComponent_Conditional_2_Conditional_4_Conditional_0_Conditional_13_For_2_Template, 1, 1, "aclogbook-logbook-aircraft-list-item", 18, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.logbookPagingService.currentPage());
  }
}
function LogbookAircraftComponent_Conditional_2_Conditional_4_Conditional_0_For_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "aclogbook-logbook-aircraft-card", 18);
  }
  if (rf & 2) {
    const aircraft_r5 = ctx.$implicit;
    i0.ɵɵproperty("aircraft", aircraft_r5);
  }
}
function LogbookAircraftComponent_Conditional_2_Conditional_4_Conditional_0_Conditional_18_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19)(1, "span", 20);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "g-pagination", 23);
    i0.ɵɵlistener("g-page-changed", function LogbookAircraftComponent_Conditional_2_Conditional_4_Conditional_0_Conditional_18_Template_g_pagination_g_page_changed_3_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.updatePage($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate3(" Showing ", ctx_r1.firstAircraftNumberOnCurrentPage(), "-", ctx_r1.lastAircraftNumberOnCurrentPage(), " of ", ctx_r1.logbookPagingService.totalFilteredAircraft(), " Aircraft ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("currentPage", ctx_r1.logbookPagingService.currentPageNumber() + 1);
    i0.ɵɵpropertyInterpolate("totalPages", ctx_r1.logbookPagingService.numberOfPages());
  }
}
function LogbookAircraftComponent_Conditional_2_Conditional_4_Conditional_0_Conditional_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 20);
    i0.ɵɵtext(1, "No search results found");
    i0.ɵɵelementEnd();
  }
}
function LogbookAircraftComponent_Conditional_2_Conditional_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "g-input", 4);
    i0.ɵɵelement(2, "input", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, LogbookAircraftComponent_Conditional_2_Conditional_4_Conditional_0_Conditional_3_Template, 12, 1, "g-drop-down", 6);
    i0.ɵɵelementStart(4, "div", 7);
    i0.ɵɵtemplate(5, LogbookAircraftComponent_Conditional_2_Conditional_4_Conditional_0_Conditional_5_Template, 4, 2, "div", 8);
    i0.ɵɵelementStart(6, "div", 9)(7, "button", 10);
    i0.ɵɵlistener("click", function LogbookAircraftComponent_Conditional_2_Conditional_4_Conditional_0_Template_button_click_7_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.setViewMode("LIST"));
    });
    i0.ɵɵelement(8, "fly-icon", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "button", 12);
    i0.ɵɵlistener("click", function LogbookAircraftComponent_Conditional_2_Conditional_4_Conditional_0_Template_button_click_9_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.setViewMode("CARD"));
    });
    i0.ɵɵelement(10, "fly-icon", 13);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(11, "div", 14);
    i0.ɵɵtemplate(12, LogbookAircraftComponent_Conditional_2_Conditional_4_Conditional_0_Conditional_12_Template, 3, 0, "div", 15)(13, LogbookAircraftComponent_Conditional_2_Conditional_4_Conditional_0_Conditional_13_Template, 3, 0, "div", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 17)(15, "div", 15);
    i0.ɵɵrepeaterCreate(16, LogbookAircraftComponent_Conditional_2_Conditional_4_Conditional_0_For_17_Template, 1, 1, "aclogbook-logbook-aircraft-card", 18, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(18, LogbookAircraftComponent_Conditional_2_Conditional_4_Conditional_0_Conditional_18_Template, 4, 5, "div", 19)(19, LogbookAircraftComponent_Conditional_2_Conditional_4_Conditional_0_Conditional_19_Template, 2, 0, "span", 20);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formControl", ctx_r1.searchControl);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.logbookPagingService.totalNumberOfAircraft() > ctx_r1.defaultAircraftPerPage ? 3 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.uploadLogsEnabled ? 5 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c16, ctx_r1.viewMode === "LIST"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c16, ctx_r1.viewMode === "CARD"));
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.viewMode === "CARD" ? 12 : ctx_r1.viewMode === "LIST" ? 13 : -1);
    i0.ɵɵadvance(4);
    i0.ɵɵrepeater(ctx_r1.logbookPagingService.currentPage());
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.logbookPagingService.totalNumberOfAircraft() > 1 && ctx_r1.aircraftOnCurrentPage() > 0 ? 18 : 19);
  }
}
function LogbookAircraftComponent_Conditional_2_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, LogbookAircraftComponent_Conditional_2_Conditional_4_Conditional_0_Template, 20, 11);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r1.logbookPagingService.currentPage() != null ? 0 : -1);
  }
}
function LogbookAircraftComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h1");
    i0.ɵɵtext(1, "Aircraft Flight Logs");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, LogbookAircraftComponent_Conditional_2_Conditional_2_Template, 1, 0, "g-loader", 1)(3, LogbookAircraftComponent_Conditional_2_Conditional_3_Template, 2, 0, "span", 2)(4, LogbookAircraftComponent_Conditional_2_Conditional_4_Template, 1, 1);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.logbookPagingService.isLoading() ? 2 : ctx_r1.logbookPagingService.hasError() ? 3 : 4);
  }
}
let AircraftFlightLogPlaybackService = /*#__PURE__*/(() => {
  class AircraftFlightLogPlaybackService {
    currentIndex = signal(0);
    playbackSpeed = signal(1);
    flightLogData = signal([]);
    logLength = computed(() => this.flightLogData().length);
    _playing = false;
    playbackInterval;
    get playing() {
      return this._playing;
    }
    play() {
      if (!this._playing) {
        this._playing = true;
      }
      if (this.currentIndex() === this.logLength() - 1) {
        this.currentIndex.set(0);
      }
      this.startPlayback();
    }
    pause() {
      if (this._playing) {
        this._playing = false;
      }
      clearInterval(this.playbackInterval);
    }
    setPlaybackSpeed(speed) {
      this.playbackSpeed.set(speed);
    }
    setCurrentIndex(index) {
      this.currentIndex.set(index);
      if (this._playing) {
        this.pause();
      }
    }
    reset() {
      this.setCurrentIndex(0);
      this.setPlaybackSpeed(1);
    }
    startPlayback() {
      let lastUpdate = performance.now();
      this.playbackInterval = setInterval(() => {
        if (!this._playing) {
          this._playing = true;
        }
        const now = performance.now();
        const elapsed = now - lastUpdate;
        if (elapsed >= 1000 / this.playbackSpeed()) {
          const nextIndex = this.currentIndex() + 1;
          if (nextIndex < this.logLength()) {
            this.currentIndex.set(nextIndex);
          } else {
            this.pause();
          }
          lastUpdate = now;
        }
      }, 0);
    }
    static ɵfac = function AircraftFlightLogPlaybackService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AircraftFlightLogPlaybackService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AircraftFlightLogPlaybackService,
      factory: AircraftFlightLogPlaybackService.ɵfac
    });
  }
  return AircraftFlightLogPlaybackService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LogDetailsChartService = /*#__PURE__*/(() => {
  class LogDetailsChartService {
    chartRef;
    aircraftFlightLogPlaybackService = inject(AircraftFlightLogPlaybackService);
    currentTimestamp = computed(this.computeCurrentTimestamp.bind(this));
    constructor() {
      toObservable(this.currentTimestamp).pipe(skip(1), takeUntilDestroyed()).subscribe(timestamp => this.renderCurrentTimestampElements(timestamp));
    }
    /**
     * This initialization method should be called in the ngAfterViewInit lifecycle hook since it requires the canvas to be rendered
     * @param canvasRef A reference to the HTML canvas element where the chart will be rendered
     * @param dataSet1 Required data set to display using the left axis
     * @param dataSet2 Required data set to display using the right axis
     */
    initialize(canvasRef, dataSet1, dataSet2) {
      Chart.register(annotationPlugin, CategoryScale, Colors, LinearScale, LineController, LineElement, Legend, PointElement, TimeScale, Tooltip, zoomPlugin);
      this.chartRef = new Chart(canvasRef, {
        data: this.formatDataset(dataSet1, dataSet2),
        type: 'line',
        options: {
          maintainAspectRatio: false,
          parsing: false,
          animation: false,
          normalized: true,
          font: {
            family: 'Roboto'
          },
          plugins: {
            tooltip: {
              enabled: true,
              backgroundColor: '#000000',
              caretPadding: 10
            },
            annotation: {
              animations: {
                numbers: {
                  duration: 0
                }
              }
            },
            zoom: {
              zoom: {
                wheel: {
                  enabled: true
                },
                pinch: {
                  enabled: true
                },
                mode: 'x'
              },
              pan: {
                enabled: true,
                mode: 'x'
              },
              limits: {
                x: {
                  min: 'original',
                  max: 'original',
                  minRange: 10000 // Divide by 1000 to determine the minimum number of data points
                }
              }
            }
          },
          elements: {
            line: {
              borderJoinStyle: 'round',
              spanGaps: false,
              tension: 0.01
            },
            point: {
              radius: 0,
              hoverRadius: 5
            }
          },
          interaction: {
            axis: 'x',
            intersect: false
          },
          scales: this.generateScalesConfig(dataSet1, dataSet2),
          onClick: (_event, elements) => this.aircraftFlightLogPlaybackService.setCurrentIndex(elements[0].index)
        }
      });
    }
    /**
     * Updates the data on the chart via the provided data sets. Only one data set is required, but a second one
     * can be provided and rendered alongside the first one.
     * @param dataSet1 Required data set to display using the left axis
     * @param dataSet2 Optional data set to display using the right axis
     */
    updateData(dataSet1, dataSet2) {
      if (this.chartRef == null) {
        throw new Error('Chart must be initialized before updating its data');
      }
      this.chartRef.options.scales = this.generateScalesConfig(dataSet1, dataSet2);
      this.chartRef.data = this.formatDataset(dataSet1, dataSet2);
      this.chartRef.update();
    }
    formatDataset(dataSet1, dataSet2) {
      const formattedData = {
        datasets: [{
          label: dataSet1.label,
          data: dataSet1.data.sort((a, b) => a.x - b.x),
          borderColor: '#106FAD',
          // Garmin Blue
          backgroundColor: '#106FAD',
          yAxisID: 'left'
        }]
      };
      if (dataSet2 != null) {
        formattedData.datasets.push({
          label: dataSet2.label,
          data: dataSet2.data.sort((a, b) => a.x - b.x),
          borderColor: '#6DCFF6',
          // Candy Blue
          backgroundColor: '#6DCFF6',
          yAxisID: 'right'
        });
      }
      return formattedData;
    }
    // The type 'any' is purposely used here because Chart.js does not properly define its data type for the scales config object
    generateScalesConfig(dataSet1, dataSet2) {
      return {
        x: {
          type: 'time',
          axis: 'x',
          bounds: 'ticks',
          time: {
            unit: 'minute',
            displayFormats: {
              minute: 'kk:mm'
            },
            tooltipFormat: 'kk:mm:ss'
          },
          ticks: {
            autoSkip: true,
            autoSkipPadding: 20,
            minRotation: 0,
            maxRotation: 0,
            padding: 10
          },
          border: {
            display: false
          },
          grid: {
            drawTicks: false
          }
        },
        left: {
          type: 'linear',
          axis: 'y',
          display: true,
          position: 'left',
          title: {
            display: true,
            text: dataSet1.label,
            font: {
              family: 'Roboto'
            }
          },
          border: {
            display: false
          },
          ticks: {
            autoSkip: true,
            autoSkipPadding: 10,
            minRotation: 0,
            maxRotation: 0,
            padding: 10
          },
          grid: {
            drawTicks: false
          }
        },
        right: {
          type: 'linear',
          axis: 'y',
          display: dataSet2 != null,
          position: 'right',
          title: {
            display: true,
            text: dataSet2?.label ?? '',
            font: {
              family: 'Roboto'
            }
          },
          grid: {
            drawOnChartArea: false,
            drawTicks: false
          },
          border: {
            display: false
          },
          ticks: {
            autoSkip: true,
            autoSkipPadding: 10,
            minRotation: 0,
            maxRotation: 0,
            padding: 10
          }
        }
      };
    }
    computeCurrentTimestamp() {
      return this.aircraftFlightLogPlaybackService.flightLogData()[this.aircraftFlightLogPlaybackService.currentIndex()].timestamp;
    }
    renderCurrentTimestampElements(timestamp) {
      if (this.chartRef?.tooltip == null || this.chartRef.options?.plugins?.annotation == null) {
        return;
      }
      this.chartRef.options.plugins.annotation.annotations = [{
        type: 'line',
        scaleID: 'x',
        value: timestamp,
        borderColor: '#4BB450',
        // Insignia Green
        borderWidth: 2
      }];
      const currentDataPoints = [{
        datasetIndex: 0,
        index: this.aircraftFlightLogPlaybackService.currentIndex()
      }];
      if (this.chartRef.data.datasets.length === 2) {
        currentDataPoints.push({
          datasetIndex: 1,
          index: this.aircraftFlightLogPlaybackService.currentIndex()
        });
      }
      this.chartRef.tooltip.setActiveElements(currentDataPoints, {
        x: (this.chartRef.chartArea.left + this.chartRef.chartArea.right) / 2,
        y: (this.chartRef.chartArea.top + this.chartRef.chartArea.bottom) / 2
      });
      this.chartRef.update();
    }
    static ɵfac = function LogDetailsChartService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LogDetailsChartService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: LogDetailsChartService,
      factory: LogDetailsChartService.ɵfac
    });
  }
  return LogDetailsChartService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AircraftFlightLogPlaybackControlsProgressBarComponent = /*#__PURE__*/(() => {
  class AircraftFlightLogPlaybackControlsProgressBarComponent {
    aircraftFlightLogPlaybackService = inject(AircraftFlightLogPlaybackService);
    range = viewChild.required('range');
    rangeControl = new FormControl(this.aircraftFlightLogPlaybackService.currentIndex());
    constructor() {
      effect(() => {
        const progress = +this.aircraftFlightLogPlaybackService.currentIndex() / +this.aircraftFlightLogPlaybackService.logLength() * 100;
        const slider = this.range().nativeElement;
        slider.style.background = `linear-gradient(to right, black ${progress}%, #D9D9D9 ${progress}%)`;
      });
      this.rangeControl.valueChanges.pipe(takeUntilDestroyed()).subscribe(value => {
        this.aircraftFlightLogPlaybackService.setCurrentIndex(value);
      });
    }
    static ɵfac = function AircraftFlightLogPlaybackControlsProgressBarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AircraftFlightLogPlaybackControlsProgressBarComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AircraftFlightLogPlaybackControlsProgressBarComponent,
      selectors: [["aclogbook-aircraft-flight-log-playback-controls-progress-bar"]],
      viewQuery: function AircraftFlightLogPlaybackControlsProgressBarComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuerySignal(ctx.range, _c0, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
        }
      },
      decls: 3,
      vars: 3,
      consts: [["range", ""], [1, "range"], ["type", "range", "min", "0", 1, "range-input", 3, "formControl", "max", "value"]],
      template: function AircraftFlightLogPlaybackControlsProgressBarComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 1);
          i0.ɵɵelement(1, "input", 2, 0);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵpropertyInterpolate("max", ctx.aircraftFlightLogPlaybackService.logLength() - 1);
          i0.ɵɵpropertyInterpolate("value", ctx.aircraftFlightLogPlaybackService.currentIndex());
          i0.ɵɵproperty("formControl", ctx.rangeControl);
        }
      },
      dependencies: [ReactiveFormsModule, i3.DefaultValueAccessor, i3.RangeValueAccessor, i3.NgControlStatus, i3.FormControlDirective],
      styles: ["[_nghost-%COMP%]{width:100%}.range[_ngcontent-%COMP%]{display:flex;align-items:center;width:100%}.range-input[_ngcontent-%COMP%]{-webkit-appearance:none;appearance:none;width:100%;cursor:pointer;outline:none;border-radius:15px;height:.2rem}.range-input[_ngcontent-%COMP%]::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;height:.9rem;width:.9rem;background-color:#eee;border-radius:50%;border:solid 3px #000}.range-input[_ngcontent-%COMP%]::-moz-range-thumb{height:.9rem;width:.9rem;background-color:#eee;border-radius:50%;border:solid 3px #000}"]
    });
  }
  return AircraftFlightLogPlaybackControlsProgressBarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AircraftFlightLogPlaybackControlsComponent = /*#__PURE__*/(() => {
  class AircraftFlightLogPlaybackControlsComponent {
    aircraftFlightLogPlaybackService = inject(AircraftFlightLogPlaybackService);
    ngOnInit() {
      this.aircraftFlightLogPlaybackService.reset();
    }
    setPlaybackSpeed(event) {
      const target = event.target;
      const newIndex = parseInt(target.value);
      this.aircraftFlightLogPlaybackService.setPlaybackSpeed(newIndex);
    }
    static ɵfac = function AircraftFlightLogPlaybackControlsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AircraftFlightLogPlaybackControlsComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AircraftFlightLogPlaybackControlsComponent,
      selectors: [["aclogbook-aircraft-flight-log-playback-controls"]],
      decls: 13,
      vars: 1,
      consts: [[1, "playback-control"], ["type", "button", "title", "Play"], ["type", "button", "title", "Pause"], ["name", "playbackSpeed", 1, "playback-speed", 3, "change"], ["value", "1"], ["value", "5"], ["value", "10"], ["value", "30"], ["type", "button", "title", "Play", 3, "click"], ["icon", "play", 1, "icon", "size-standard"], ["type", "button", "title", "Pause", 3, "click"], ["icon", "pause", 1, "icon", "size-standard"]],
      template: function AircraftFlightLogPlaybackControlsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, AircraftFlightLogPlaybackControlsComponent_Conditional_1_Template, 2, 0, "button", 1)(2, AircraftFlightLogPlaybackControlsComponent_Conditional_2_Template, 2, 0, "button", 2);
          i0.ɵɵelement(3, "aclogbook-aircraft-flight-log-playback-controls-progress-bar");
          i0.ɵɵelementStart(4, "select", 3);
          i0.ɵɵlistener("change", function AircraftFlightLogPlaybackControlsComponent_Template_select_change_4_listener($event) {
            return ctx.setPlaybackSpeed($event);
          });
          i0.ɵɵelementStart(5, "option", 4);
          i0.ɵɵtext(6, "1x");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(7, "option", 5);
          i0.ɵɵtext(8, "5x");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(9, "option", 6);
          i0.ɵɵtext(10, "10x");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(11, "option", 7);
          i0.ɵɵtext(12, "30x");
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵconditional(!ctx.aircraftFlightLogPlaybackService.playing ? 1 : 2);
        }
      },
      dependencies: [ComponentsGlobalWebModule, AircraftFlightLogPlaybackControlsProgressBarComponent, IconComponent],
      styles: [".icon.size-small[_ngcontent-%COMP%]{width:.875rem;height:.875rem}.icon.size-standard[_ngcontent-%COMP%]{width:1.125rem;height:1.125rem}.icon.size-large[_ngcontent-%COMP%]{width:1.75rem;height:1.75rem}.icon.color-black[_ngcontent-%COMP%]{color:#000}.icon.color-red[_ngcontent-%COMP%]{color:#920000}.icon.color-green[_ngcontent-%COMP%]{color:#4bb450}.icon.color-yellow[_ngcontent-%COMP%]{color:#ffaf33}.icon.color-garmin-blue[_ngcontent-%COMP%]{color:#106fad}.icon.color-dark-gray[_ngcontent-%COMP%]{color:#737373}.icon.effect-hover[_ngcontent-%COMP%]{opacity:0;transition:opacity .2s}.icon.effect-hover[_ngcontent-%COMP%]:hover, .icon.effect-hover[_ngcontent-%COMP%]:focus-visible{opacity:1}.icon.prop-clickable[_ngcontent-%COMP%]{cursor:pointer}.playback-control[_ngcontent-%COMP%]{padding:1rem;display:flex;flex-direction:row;gap:1rem;align-items:center}.icon[_ngcontent-%COMP%]{width:.5rem;height:.5rem}.playback-speed[_ngcontent-%COMP%]{appearance:none;border:.15rem solid rgb(216.75,216.75,216.75);padding:.3rem .5rem;cursor:pointer;border-radius:25%;text-align:center}"]
    });
  }
  return AircraftFlightLogPlaybackControlsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const DEFAULT_LOG_DETAILS_CHART_DATA_OPTION_LEFT_AXIS = {
  fieldName: 'indicatedBarometricAltitude',
  displayName: 'Indicated Barometric Altitude',
  unit: 'ft'
};
const DEFAULT_LOG_DETAILS_CHART_DATA_OPTION_RIGHT_AXIS = {
  fieldName: 'indicatedAirspeed',
  displayName: 'Indicated Airspeed',
  unit: 'knots'
};
const LOG_DETAILS_CHART_DATA_AUTOPILOT_OPTIONS = [{
  fieldName: 'autopilotAltitudeCommand',
  displayName: 'Autopilot Altitude Command',
  unit: 'ft'
}, {
  fieldName: 'autopilotFlightDirectorPitchCommand',
  displayName: 'Autopilot Flight Director Pitch Command',
  unit: '°'
}, {
  fieldName: 'autopilotFlightDirectorRollCommand',
  displayName: 'Autopilot Flight Director Roll Command',
  unit: '°'
}, {
  fieldName: 'autopilotMonitorAndFaultFlags',
  displayName: 'Autopilot Monitor And Fault Flags',
  unit: 'count'
}, {
  fieldName: 'autopilotPitchCommand',
  displayName: 'Autopilot Pitch Command',
  unit: '°'
}, {
  fieldName: 'autopilotPitchTorque',
  displayName: 'Autopilot Pitch Torque',
  unit: '%'
}, {
  fieldName: 'autopilotPitchTrimTorque',
  displayName: 'Autopilot Pitch Trim Torque',
  unit: '%'
}, {
  fieldName: 'autopilotRollCommand',
  displayName: 'Autopilot Roll Command',
  unit: '°'
}, {
  fieldName: 'autopilotRollTorque',
  displayName: 'Autopilot Roll Torque',
  unit: '%'
}, {
  fieldName: 'autopilotRollTrimTorque',
  displayName: 'Autopilot Roll Trim Torque',
  unit: '%'
}, {
  fieldName: 'autopilotVerticalSpeedCommand',
  displayName: 'Autopilot Vertical Speed Command',
  unit: 'ft/min'
}, {
  fieldName: 'autopilotYawTorque',
  displayName: 'Autopilot Yaw Torque',
  unit: '%'
}, {
  fieldName: 'selectedAirspeed',
  displayName: 'Selected Airspeed',
  unit: 'knots'
}, {
  fieldName: 'selectedAltitude',
  displayName: 'Selected Altitude',
  unit: 'ft'
}, {
  fieldName: 'selectedVerticalSpeed',
  displayName: 'Selected Vertical Speed',
  unit: 'ft/min'
}];
const LOG_DETAILS_CHART_DATA_AVIONICS_OPTIONS = [{
  fieldName: 'avionicsVacuum1Pressure',
  displayName: 'Avionics Vacuum 1 Pressure',
  unit: 'in Hg'
}, {
  fieldName: 'avionicsVacuum2Pressure',
  displayName: 'Avionics Vacuum 2 Pressure',
  unit: 'in Hg'
}, {
  fieldName: 'eisOutsideAirTemperature',
  displayName: 'EIS Outside Air Temperature',
  unit: '°C'
}, {
  fieldName: 'flightDirectorTargetAltitude',
  displayName: 'Flight Director Target Altitude',
  unit: 'ft'
}, DEFAULT_LOG_DETAILS_CHART_DATA_OPTION_RIGHT_AXIS, DEFAULT_LOG_DETAILS_CHART_DATA_OPTION_LEFT_AXIS, {
  fieldName: 'lruBattery',
  displayName: 'LRU Battery',
  unit: '%'
}, {
  fieldName: 'lruLcdTemperature',
  displayName: 'LRU LCD Temperature',
  unit: '°C'
}, {
  fieldName: 'lruTemperature',
  displayName: 'LRU Temperature',
  unit: '°C'
}, {
  fieldName: 'selectedBarometricPressureSetting',
  displayName: 'Selected Barometric Pressure Setting',
  unit: 'in Hg'
}];
const LOG_DETAILS_CHART_DATA_POWER_OPTIONS = [{
  fieldName: 'alternator1Amps',
  displayName: 'Alternator 1 Amps',
  unit: 'A'
}, {
  fieldName: 'alternator2Amps',
  displayName: 'Alternator 2 Amps',
  unit: 'A'
}, {
  fieldName: 'battery1Amps',
  displayName: 'Battery 1 Amps',
  unit: 'A'
}, {
  fieldName: 'battery1Volts',
  displayName: 'Battery 1 Volts',
  unit: 'V'
}, {
  fieldName: 'battery2Amps',
  displayName: 'Battery 2 Amps',
  unit: 'A'
}, {
  fieldName: 'battery2Volts',
  displayName: 'Battery 2 Volts',
  unit: 'V'
}, {
  fieldName: 'batteryCharge',
  displayName: 'Battery Charge',
  unit: '%'
}, {
  fieldName: 'dcBus1Volts',
  displayName: 'DC Bus 1 Volts',
  unit: 'V'
}, {
  fieldName: 'dcBus2Volts',
  displayName: 'DC Bus 2 Volts',
  unit: 'V'
}];
const LOG_DETAILS_CHART_DATA_ENGINE_1_OPTIONS = [{
  fieldName: 'engine1CarburetorTemperature',
  displayName: 'Engine 1 Carburetor Temperature',
  unit: '°F'
}, {
  fieldName: 'engine1CompressorDischargeTemperature',
  displayName: 'Engine 1 Compressor Discharge Temperature',
  unit: '°F'
}, {
  fieldName: 'engine1CompressorInletAirTemperature',
  displayName: 'Engine 1 Compressor Inlet Air Temperature',
  unit: '°F'
}, {
  fieldName: 'engine1CylinderHead1Temperature',
  displayName: 'Engine 1 Cylinder Head 1 Temperature',
  unit: '°F'
}, {
  fieldName: 'engine1CylinderHead2Temperature',
  displayName: 'Engine 1 Cylinder Head 2 Temperature',
  unit: '°F'
}, {
  fieldName: 'engine1CylinderHead3Temperature',
  displayName: 'Engine 1 Cylinder Head 3 Temperature',
  unit: '°F'
}, {
  fieldName: 'engine1CylinderHead4Temperature',
  displayName: 'Engine 1 Cylinder Head 4 Temperature',
  unit: '°F'
}, {
  fieldName: 'engine1CylinderHead5Temperature',
  displayName: 'Engine 1 Cylinder Head 5 Temperature',
  unit: '°F'
}, {
  fieldName: 'engine1CylinderHead6Temperature',
  displayName: 'Engine 1 Cylinder Head 6 Temperature',
  unit: '°F'
}, {
  fieldName: 'engine1CylinderHeadTemperatureCoolingRate',
  displayName: 'Engine 1 Cylinder Head Temperature Cooling Rate',
  unit: '°F/min'
}, {
  fieldName: 'engine1ExhaustGasTemperature1',
  displayName: 'Engine 1 Exhaust Gas Temperature 1',
  unit: '°F'
}, {
  fieldName: 'engine1ExhaustGasTemperature2',
  displayName: 'Engine 1 Exhaust Gas Temperature 2',
  unit: '°F'
}, {
  fieldName: 'engine1ExhaustGasTemperature3',
  displayName: 'Engine 1 Exhaust Gas Temperature 3',
  unit: '°F'
}, {
  fieldName: 'engine1ExhaustGasTemperature4',
  displayName: 'Engine 1 Exhaust Gas Temperature 4',
  unit: '°F'
}, {
  fieldName: 'engine1ExhaustGasTemperature5',
  displayName: 'Engine 1 Exhaust Gas Temperature 5',
  unit: '°F'
}, {
  fieldName: 'engine1ExhaustGasTemperature6',
  displayName: 'Engine 1 Exhaust Gas Temperature 6',
  unit: '°F'
}, {
  fieldName: 'engine1FuelFlow',
  displayName: 'Engine 1 Fuel Flow',
  unit: 'gal/hr'
}, {
  fieldName: 'engine1FuelPressure',
  displayName: 'Engine 1 Fuel Pressure',
  unit: 'psi'
}, {
  fieldName: 'engine1GeneratorTurbineCompressorTurbineRpm',
  displayName: 'Engine 1 Generator Turbine Compressor RPM',
  unit: 'rpm'
}, {
  fieldName: 'engine1GeneratorTurbineCompressorTurbineRpmPercent',
  displayName: 'Engine 1 Generator Turbine Compressor RPM Percent',
  unit: '%'
}, {
  fieldName: 'engine1HighPressureCompressorRpmPercent',
  displayName: 'Engine 1 High Pressure Compressor RPM Percent',
  unit: '%'
}, {
  fieldName: 'engine1InterTurbineTemperature',
  displayName: 'Engine 1 Inter Turbine Temperature',
  unit: '°C'
}, {
  fieldName: 'engine1LowPressureCompressorRpmPercent',
  displayName: 'Engine 1 Low Pressure Compressor RPM Percent',
  unit: '%'
}, {
  fieldName: 'engine1ManifoldPressure',
  displayName: 'Engine 1 Manifold Pressure',
  unit: 'in Hg'
}, {
  fieldName: 'engine1OilPressure',
  displayName: 'Engine 1 Oil Pressure',
  unit: 'psi'
}, {
  fieldName: 'engine1OilTemperature',
  displayName: 'Engine 1 Oil Temperature',
  unit: '°F'
}, {
  fieldName: 'engine1OutsideAirTemperature',
  displayName: 'Engine 1 Outside Air Temperature',
  unit: '°C'
}, {
  fieldName: 'engine1PowerPercent',
  displayName: 'Engine 1 Power Percent',
  unit: '%'
}, {
  fieldName: 'engine1PowerTurbineRpm',
  displayName: 'Engine 1 Power Turbine RPM',
  unit: 'rpm'
}, {
  fieldName: 'engine1PowerTurbineRpmPercent',
  displayName: 'Engine 1 Power Turbine RPM Percent',
  unit: '%'
}, {
  fieldName: 'engine1PrimaryExhaustGasTemperature',
  displayName: 'Engine 1 Primary Exhaust Gas Temperature',
  unit: '°F'
}, {
  fieldName: 'engine1RevolutionsPerMinute',
  displayName: 'Engine 1 RPM',
  unit: 'rpm'
}, {
  fieldName: 'engine1TorqueInFootPounds',
  displayName: 'Engine 1 Torque - Foot Pounds',
  unit: 'ft lbs'
}, {
  fieldName: 'engine1TorqueInPercent',
  displayName: 'Engine 1 Torque - Percentage',
  unit: '%'
}, {
  fieldName: 'engine1TorqueInPoundsPerSquareInch',
  displayName: 'Engine 1 Torque - PSI',
  unit: 'psi'
}, {
  fieldName: 'engine1Turbine1InletTemperature',
  displayName: 'Engine 1 Turbine 1 Inlet Temperature',
  unit: '°F'
}, {
  fieldName: 'engine1Turbine2InletTemperature',
  displayName: 'Engine 1 Turbine 2 Inlet Temperature',
  unit: '°F'
}];
const LOG_DETAILS_CHART_DATA_ENGINE_2_OPTIONS = [{
  fieldName: 'engine2CarburetorTemperature',
  displayName: 'Engine 2 Carburetor Temperature',
  unit: '°F'
}, {
  fieldName: 'engine2CompressorDischargeTemperature',
  displayName: 'Engine 2 Compressor Discharge Temperature',
  unit: '°F'
}, {
  fieldName: 'engine2CompressorInletAirTemperature',
  displayName: 'Engine 2 Compressor Inlet Air Temperature',
  unit: '°F'
}, {
  fieldName: 'engine2CylinderHead1Temperature',
  displayName: 'Engine 2 Cylinder Head 1 Temperature',
  unit: '°F'
}, {
  fieldName: 'engine2CylinderHead2Temperature',
  displayName: 'Engine 2 Cylinder Head 2 Temperature',
  unit: '°F'
}, {
  fieldName: 'engine2CylinderHead3Temperature',
  displayName: 'Engine 2 Cylinder Head 3 Temperature',
  unit: '°F'
}, {
  fieldName: 'engine2CylinderHead4Temperature',
  displayName: 'Engine 2 Cylinder Head 4 Temperature',
  unit: '°F'
}, {
  fieldName: 'engine2CylinderHead5Temperature',
  displayName: 'Engine 2 Cylinder Head 5 Temperature',
  unit: '°F'
}, {
  fieldName: 'engine2CylinderHead6Temperature',
  displayName: 'Engine 2 Cylinder Head 6 Temperature',
  unit: '°F'
}, {
  fieldName: 'engine2CylinderHeadTemperatureCoolingRate',
  displayName: 'Engine 2 Cylinder Head Temperature Cooling Rate',
  unit: '°F/min'
}, {
  fieldName: 'engine2ExhaustGasTemperature1',
  displayName: 'Engine 2 Exhaust Gas Temperature 1',
  unit: '°F'
}, {
  fieldName: 'engine2ExhaustGasTemperature2',
  displayName: 'Engine 2 Exhaust Gas Temperature 2',
  unit: '°F'
}, {
  fieldName: 'engine2ExhaustGasTemperature3',
  displayName: 'Engine 2 Exhaust Gas Temperature 3',
  unit: '°F'
}, {
  fieldName: 'engine2ExhaustGasTemperature4',
  displayName: 'Engine 2 Exhaust Gas Temperature 4',
  unit: '°F'
}, {
  fieldName: 'engine2ExhaustGasTemperature5',
  displayName: 'Engine 2 Exhaust Gas Temperature 5',
  unit: '°F'
}, {
  fieldName: 'engine2ExhaustGasTemperature6',
  displayName: 'Engine 2 Exhaust Gas Temperature 6',
  unit: '°F'
}, {
  fieldName: 'engine2FuelFlow',
  displayName: 'Engine 2 Fuel Flow',
  unit: 'gal/hr'
}, {
  fieldName: 'engine2FuelPressure',
  displayName: 'Engine 2 Fuel Pressure',
  unit: 'psi'
}, {
  fieldName: 'engine2GeneratorTurbineCompressorTurbineRpm',
  displayName: 'Engine 2 Generator Turbine Compressor RPM',
  unit: 'rpm'
}, {
  fieldName: 'engine2GeneratorTurbineCompressorTurbineRpmPercent',
  displayName: 'Engine 2 Generator Turbine Compressor RPM Percent',
  unit: '%'
}, {
  fieldName: 'engine2HighPressureCompressorRpmPercent',
  displayName: 'Engine 2 High Pressure Compressor RPM Percent',
  unit: '%'
}, {
  fieldName: 'engine2InterTurbineTemperature',
  displayName: 'Engine 2 Inter Turbine Temperature',
  unit: '°C'
}, {
  fieldName: 'engine2LowPressureCompressorRpmPercent',
  displayName: 'Engine 2 Low Pressure Compressor RPM Percent',
  unit: '%'
}, {
  fieldName: 'engine2ManifoldPressure',
  displayName: 'Engine 2 Manifold Pressure',
  unit: 'in Hg'
}, {
  fieldName: 'engine2OilPressure',
  displayName: 'Engine 2 Oil Pressure',
  unit: 'psi'
}, {
  fieldName: 'engine2OilTemperature',
  displayName: 'Engine 2 Oil Temperature',
  unit: '°F'
}, {
  fieldName: 'engine2OutsideAirTemperature',
  displayName: 'Engine 2 Outside Air Temperature',
  unit: '°C'
}, {
  fieldName: 'engine2PowerPercent',
  displayName: 'Engine 2 Power Percent',
  unit: '%'
}, {
  fieldName: 'engine2PowerTurbineRpm',
  displayName: 'Engine 2 Power Turbine RPM',
  unit: 'rpm'
}, {
  fieldName: 'engine2PowerTurbineRpmPercent',
  displayName: 'Engine 2 Power Turbine RPM Percent',
  unit: '%'
}, {
  fieldName: 'engine2PrimaryExhaustGasTemperature',
  displayName: 'Engine 2 Primary Exhaust Gas Temperature',
  unit: '°F'
}, {
  fieldName: 'engine2RevolutionsPerMinute',
  displayName: 'Engine 2 RPM',
  unit: 'rpm'
}, {
  fieldName: 'engine2TorqueInFootPounds',
  displayName: 'Engine 2 Torque - Foot Pounds',
  unit: 'ft lbs'
}, {
  fieldName: 'engine2TorqueInPercent',
  displayName: 'Engine 2 Torque - Percentage',
  unit: '%'
}, {
  fieldName: 'engine2TorqueInPoundsPerSquareInch',
  displayName: 'Engine 2 Torque - PSI',
  unit: 'psi'
}, {
  fieldName: 'engine2Turbine1InletTemperature',
  displayName: 'Engine 2 Turbine 1 Inlet Temperature',
  unit: '°F'
}, {
  fieldName: 'engine2Turbine2InletTemperature',
  displayName: 'Engine 2 Turbine 2 Inlet Temperature',
  unit: '°F'
}];
const LOG_DETAILS_CHART_DATA_FUEL_OPTIONS = [{
  fieldName: 'fuelAux1Quantity',
  displayName: 'Fuel Aux 1 Quantity',
  unit: 'gal'
}, {
  fieldName: 'fuelAux1QuantityWeight',
  displayName: 'Fuel Aux 1 Quantity Weight',
  unit: 'lbs'
}, {
  fieldName: 'fuelAux2Quantity',
  displayName: 'Fuel Aux 2 Quantity',
  unit: 'gal'
}, {
  fieldName: 'fuelAux2QuantityWeight',
  displayName: 'Fuel Aux 2 Quantity Weight',
  unit: 'lbs'
}, {
  fieldName: 'fuelAuxCenterQuantity',
  displayName: 'Fuel Aux Center Quantity',
  unit: 'gal'
}, {
  fieldName: 'fuelAuxCenterQuantityWeight',
  displayName: 'Fuel Aux Center Quantity Weight',
  unit: 'lbs'
}, {
  fieldName: 'fuelCenterQuantity',
  displayName: 'Fuel Center Quantity',
  unit: 'gal'
}, {
  fieldName: 'fuelCenterQuantityWeight',
  displayName: 'Fuel Center Quantity Weight',
  unit: 'lbs'
}, {
  fieldName: 'fuelLeftQuantity',
  displayName: 'Fuel Left Quantity',
  unit: 'gal'
}, {
  fieldName: 'fuelLeftQuantityWeight',
  displayName: 'Fuel Left Quantity Weight',
  unit: 'lbs'
}, {
  fieldName: 'fuelRightQuantity',
  displayName: 'Fuel Right Quantity',
  unit: 'gal'
}, {
  fieldName: 'fuelRightQuantityWeight',
  displayName: 'Fuel Right Quantity Weight',
  unit: 'lbs'
}];
const LOG_DETAILS_CHART_DATA_GENERAL_OPTIONS = [{
  fieldName: 'aircraftPower',
  displayName: 'Aircraft Power',
  unit: 'V'
}, {
  fieldName: 'aircraftWeight',
  displayName: 'Aircraft Weight',
  unit: 'lbs'
}, {
  fieldName: 'groundSpeed',
  displayName: 'Ground Speed',
  unit: 'knots'
}, {
  fieldName: 'lateralYAcceleration',
  displayName: 'Lateral Y Acceleration',
  unit: 'gravitational force'
}, {
  fieldName: 'longitudinalAcceleration',
  displayName: 'Longitudinal Acceleration',
  unit: 'gravitational force'
}, {
  fieldName: 'outsideAirTemperature',
  displayName: 'Outside Air Temperature',
  unit: '°C'
}, {
  fieldName: 'rudderTrimPosition',
  displayName: 'Rudder Trim Position',
  unit: '°'
}, {
  fieldName: 'trueAirspeed',
  displayName: 'True Airspeed',
  unit: 'knots'
}, {
  fieldName: 'windDirection',
  displayName: 'Wind Direction',
  unit: '°'
}, {
  fieldName: 'windSpeed',
  displayName: 'Wind Speed',
  unit: 'knots'
}, {
  fieldName: 'verticalSpeed',
  displayName: 'Vertical Speed',
  unit: 'ft/min'
}, {
  fieldName: 'verticalZAcceleration',
  displayName: 'Vertical Z Acceleration',
  unit: 'gravitational force'
}, {
  fieldName: 'carbonMonoxideLevel',
  displayName: 'Carbon Monoxide Level',
  unit: 'ppm'
}];
const LOG_DETAILS_CHART_DATA_GPS_OPTIONS = [{
  fieldName: 'gpsAltitudeRelativeToMeanSeaLevel',
  displayName: 'GPS Altitude Relative To Mean Sea Level',
  unit: 'ft'
}, {
  fieldName: 'gpsEastVelocityComponent',
  displayName: 'GPS East Velocity Component',
  unit: 'm/s'
}, {
  fieldName: 'gpsHorizontalAlertLimit',
  displayName: 'GPS Horizontal Alert Limit',
  unit: 'm'
}, {
  fieldName: 'gpsHorizontalAlertLimitSource2',
  displayName: 'GPS Horizontal Alert Limit Source 2',
  unit: 'm'
}, {
  fieldName: 'gpsHorizontalProtectionLevel',
  displayName: 'GPS Horizontal Protection Level',
  unit: 'm'
}, {
  fieldName: 'gpsHorizontalProtectionLevelSource2',
  displayName: 'GPS Horizontal Protection Level Source 2',
  unit: 'm'
}, {
  fieldName: 'gpsNorthVelocityComponent',
  displayName: 'GPS North Velocity Component',
  unit: 'm/s'
}, {
  fieldName: 'gpsPdop',
  displayName: 'GPS PDOP',
  unit: 'PDOP'
}, {
  fieldName: 'gpsUpVelocityComponent',
  displayName: 'GPS Up Velocity Component',
  unit: 'm/s'
}, {
  fieldName: 'gpsVerticalAlertLimit',
  displayName: 'GPS Vertical Alert Limit',
  unit: 'm'
}, {
  fieldName: 'gpsVerticalAlertLimitSource2',
  displayName: 'GPS Vertical Alert Limit Source 2',
  unit: 'm'
}, {
  fieldName: 'gpsVerticalSpeed',
  displayName: 'GPS Vertical Speed',
  unit: 'ft/min'
}, {
  fieldName: 'gpsWaasHorizontalProtectionLevel',
  displayName: 'GPS Waas Horizontal Protection Level',
  unit: 'm'
}, {
  fieldName: 'gpsWaasHorizontalProtectionLevelSource2',
  displayName: 'GPS Waas Horizontal Protection Level Source 2',
  unit: 'm'
}, {
  fieldName: 'gpsWaasVerticalProtectionLevel',
  displayName: 'GPS Waas Vertical Protection Level',
  unit: 'm'
}, {
  fieldName: 'gpsWaasVerticalProtectionLevelSource2',
  displayName: 'GPS Waas Vertical Protection Level Source 2',
  unit: 'm'
}, {
  fieldName: 'gpsWgs84Altitude',
  displayName: 'GPS WGS84 Altitude',
  unit: 'ft'
}];
const LOG_DETAILS_CHART_DATA_NAVIGATION_OPTIONS = [{
  fieldName: 'bearingToNextWaypoint',
  displayName: 'Bearing To Next Waypoint',
  unit: '°'
}, {
  fieldName: 'distanceToNextWaypoint',
  displayName: 'Distance To Next Waypoint',
  unit: 'nm'
}, {
  fieldName: 'selectedCourse',
  displayName: 'Selected Course',
  unit: '°'
}, {
  fieldName: 'selectedHeading',
  displayName: 'Selected Heading',
  unit: '°'
}, {
  fieldName: 'selectedTrack',
  displayName: 'Selected Track',
  unit: '°'
}, {
  fieldName: 'verticalNavigationAltitude',
  displayName: 'Vertical Navigation Altitude',
  unit: 'ft'
}, {
  fieldName: 'verticalNavigationDeviation',
  displayName: 'Vertical Navigation Deviation',
  unit: 'ft'
}, {
  fieldName: 'verticalNavigationPathAngle',
  displayName: 'Vertical Navigation Path Angle',
  unit: '°'
}];
const LOG_DETAILS_CHART_DATA_MISC_OPTIONS = [{
  fieldName: 'attitudePitchAngle',
  displayName: 'Attitude Pitch Angle',
  unit: '°'
}, {
  fieldName: 'attitudeRollAngle',
  displayName: 'Attitude Roll Angle',
  unit: '°'
}, {
  fieldName: 'horizontalCdi',
  displayName: 'Horizontal CDI',
  unit: 'full scale deflection'
}, {
  fieldName: 'magneticVariation',
  displayName: 'Magnetic Variation',
  unit: '°'
}, {
  fieldName: 'pressureAltitude',
  displayName: 'Pressure Altitude',
  unit: 'ft'
}, {
  fieldName: 'slipSkid',
  displayName: 'Slip Skid',
  unit: '°'
}, {
  fieldName: 'turnRate',
  displayName: 'Turn Rate',
  unit: '°/sec'
}, {
  fieldName: 'verticalCdi',
  displayName: 'Vertical CDI',
  unit: 'full scale deflection'
}, {
  fieldName: 'yawDamperMonitorAndFaultFlags',
  displayName: 'Yaw Damper Monitor And Fault Flags',
  unit: 'count'
}];
const LOG_DETAILS_CHART_DATA_OPTION_SECTIONS = [{
  name: 'Autopilot',
  options: LOG_DETAILS_CHART_DATA_AUTOPILOT_OPTIONS
}, {
  name: 'Avionics',
  options: LOG_DETAILS_CHART_DATA_AVIONICS_OPTIONS
}, {
  name: 'Power',
  options: LOG_DETAILS_CHART_DATA_POWER_OPTIONS
}, {
  name: 'Engine 1',
  options: LOG_DETAILS_CHART_DATA_ENGINE_1_OPTIONS
}, {
  name: 'Engine 2',
  options: LOG_DETAILS_CHART_DATA_ENGINE_2_OPTIONS
}, {
  name: 'Fuel',
  options: LOG_DETAILS_CHART_DATA_FUEL_OPTIONS
}, {
  name: 'GPS',
  options: LOG_DETAILS_CHART_DATA_GPS_OPTIONS
}, {
  name: 'General',
  options: LOG_DETAILS_CHART_DATA_GENERAL_OPTIONS
}, {
  name: 'Misc.',
  options: LOG_DETAILS_CHART_DATA_MISC_OPTIONS
}, {
  name: 'Navigation',
  options: LOG_DETAILS_CHART_DATA_NAVIGATION_OPTIONS
}];
let ZIndexService = /*#__PURE__*/(() => {
  class ZIndexService {
    zIndex = 0;
    nextZIndex() {
      this.zIndex += 1;
      return this.zIndex;
    }
    static ɵfac = function ZIndexService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZIndexService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ZIndexService,
      factory: ZIndexService.ɵfac,
      providedIn: 'root'
    });
  }
  return ZIndexService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LogDetailsChartComponent = /*#__PURE__*/(() => {
  class LogDetailsChartComponent {
    expandChartWrapper;
    chartCanvasWrapper;
    chart;
    aircraftFlightLogPlaybackService = inject(AircraftFlightLogPlaybackService);
    destroyRef = inject(DestroyRef);
    chartDataOptionSections = computed(this.computeFilteredChartDataOptionSections.bind(this));
    chartDataOptions = computed(this.computeChartDataOptions.bind(this));
    chartDataForm = new FormGroup({
      leftAxis: new FormControl(DEFAULT_LOG_DETAILS_CHART_DATA_OPTION_LEFT_AXIS.fieldName, {
        nonNullable: true
      }),
      rightAxis: new FormControl(DEFAULT_LOG_DETAILS_CHART_DATA_OPTION_RIGHT_AXIS.fieldName, {
        nonNullable: true
      })
    });
    document = inject(DOCUMENT);
    logDetailsChartService = inject(LogDetailsChartService);
    zIndexService = inject(ZIndexService);
    isChartExpand = false;
    zIndexValue = 0;
    ngOnInit() {
      this.zIndexValue = this.zIndexService.nextZIndex();
    }
    ngAfterViewInit() {
      if (this.chart == null) {
        throw new Error('Cannot initialize chart without a canvas context');
      }
      if (this.expandChartWrapper == null) {
        throw new Error('HTML element is unexpectedly null');
      }
      const initialDataSet = this.generateChartDataSets(this.chartDataForm.controls.leftAxis.value, this.chartDataForm.controls.rightAxis.value);
      this.logDetailsChartService.initialize(this.chart.nativeElement, initialDataSet.leftAxisDataSet, initialDataSet.rightAxisDataSet);
      this.chartDataForm.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        const {
          leftAxis,
          rightAxis
        } = this.chartDataForm.getRawValue();
        const dataSets = this.generateChartDataSets(leftAxis, rightAxis);
        this.logDetailsChartService.updateData(dataSets.leftAxisDataSet, dataSets.rightAxisDataSet);
      });
    }
    toggleChartExpand() {
      const chartComponent = this.expandChartWrapper?.nativeElement;
      if (this.isChartExpand) {
        if (this.document.exitFullscreen != null) {
          this.document.exitFullscreen().catch(err => console.error('Failed to exit fullscreen:', err));
          this.isChartExpand = false;
        }
      } else {
        if (chartComponent.requestFullscreen != null) {
          chartComponent.requestFullscreen().catch(err => console.error('Failed to enter fullscreen:', err));
          this.isChartExpand = true;
        }
      }
    }
    generateChartDataSets(leftAxisField, rightAxisField) {
      const leftAxisDataPoints = this.aircraftFlightLogPlaybackService.flightLogData().map(flightLogRow => {
        return {
          x: parseISO(flightLogRow.timestamp).getTime(),
          y: flightLogRow[leftAxisField] ?? Number.NaN
        };
      });
      const leftAxisDataSet = {
        data: leftAxisDataPoints,
        label: this.generateChartAxisLabel('leftAxis')
      };
      let rightAxisDataSet;
      if (rightAxisField != null) {
        const rightAxisDataPoints = this.aircraftFlightLogPlaybackService.flightLogData().map(flightLogRow => {
          return {
            x: parseISO(flightLogRow.timestamp).getTime(),
            y: flightLogRow[rightAxisField] ?? Number.NaN
          };
        });
        rightAxisDataSet = {
          data: rightAxisDataPoints,
          label: this.generateChartAxisLabel('rightAxis')
        };
      }
      return {
        leftAxisDataSet,
        rightAxisDataSet
      };
    }
    generateChartAxisLabel(axis) {
      const chartDataOption = this.chartDataOptions().find(option => option.fieldName === this.chartDataForm.controls[axis].value);
      return chartDataOption != null ? `${chartDataOption.displayName} (${chartDataOption.unit})` : '';
    }
    computeFilteredChartDataOptionSections() {
      const flightLogData = this.aircraftFlightLogPlaybackService.flightLogData();
      return LOG_DETAILS_CHART_DATA_OPTION_SECTIONS.map(section => {
        section.options = section.options.filter(option => flightLogData.some(row => {
          return row[option.fieldName] != null && !Number.isNaN(row[option.fieldName]);
        }));
        return section;
      }).filter(section => section.options.length > 0);
    }
    computeChartDataOptions() {
      return this.chartDataOptionSections().map(section => section.options).flat();
    }
    onEscapeKey() {
      if (this.document.fullscreenElement == null) {
        this.isChartExpand = false;
      }
    }
    static ɵfac = function LogDetailsChartComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LogDetailsChartComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: LogDetailsChartComponent,
      selectors: [["aclogbook-log-details-chart"]],
      viewQuery: function LogDetailsChartComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c1, 5);
          i0.ɵɵviewQuery(_c2, 5);
          i0.ɵɵviewQuery(_c3, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.expandChartWrapper = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chartCanvasWrapper = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chart = _t.first);
        }
      },
      hostBindings: function LogDetailsChartComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("fullscreenchange", function LogDetailsChartComponent_fullscreenchange_HostBindingHandler($event) {
            return ctx.onEscapeKey($event);
          }, false, i0.ɵɵresolveDocument);
        }
      },
      decls: 24,
      vars: 15,
      consts: [["expandChartWrapper", ""], ["chartCanvasWrapper", ""], ["chart", ""], [1, "expand-chart"], [3, "ngClass"], [3, "ngStyle"], [1, "expand-button"], [3, "click", "ngStyle"], ["icon", "fullscreen-arrow-up-right-down-left", 1, "icon", "size-small", "two-arrows"], [1, "data-selection-container"], ["label", "Left Axis"], [3, "formControl"], [3, "label"], ["label", "Right Axis"], ["label", "Hide Axis"], [3, "ngValue"], [1, "inverse-expand-button", 3, "click", "ngStyle"], ["icon", "inverse-fullscreen-arrow-inwards-up-right-down-left", 1, "icon", "size-large", "two-arrows-inverse"], [3, "selected"]],
      template: function LogDetailsChartComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 3, 0)(2, "div", 4, 1);
          i0.ɵɵelement(4, "canvas", 5, 2);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(6, "div", 6)(7, "button", 7);
          i0.ɵɵlistener("click", function LogDetailsChartComponent_Template_button_click_7_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.toggleChartExpand());
          });
          i0.ɵɵtemplate(8, LogDetailsChartComponent_Conditional_8_Template, 1, 0, "fly-icon", 8);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(9, "div", 9)(10, "g-drop-down", 10)(11, "select", 11);
          i0.ɵɵrepeaterCreate(12, LogDetailsChartComponent_For_13_Template, 3, 1, "optgroup", 12, i0.ɵɵrepeaterTrackByIndex);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(14, "g-drop-down", 13)(15, "select", 11)(16, "optgroup", 14)(17, "option", 15);
          i0.ɵɵtext(18, "Hidden");
          i0.ɵɵelementEnd()();
          i0.ɵɵrepeaterCreate(19, LogDetailsChartComponent_For_20_Template, 3, 1, "optgroup", 12, i0.ɵɵrepeaterTrackByIndex);
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(21, "div", 6)(22, "button", 16);
          i0.ɵɵlistener("click", function LogDetailsChartComponent_Template_button_click_22_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.toggleChartExpand());
          });
          i0.ɵɵtemplate(23, LogDetailsChartComponent_Conditional_23_Template, 1, 0, "fly-icon", 17);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngClass", ctx.isChartExpand ? "chart-wrapper-expanded" : "chart-wrapper");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(9, _c4, ctx.zIndexValue));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(11, _c4, ctx.zIndexValue));
          i0.ɵɵadvance();
          i0.ɵɵconditional(!ctx.isChartExpand ? 8 : -1);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("formControl", ctx.chartDataForm.controls.leftAxis);
          i0.ɵɵadvance();
          i0.ɵɵrepeater(ctx.chartDataOptionSections());
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("formControl", ctx.chartDataForm.controls.rightAxis);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngValue", undefined);
          i0.ɵɵadvance(2);
          i0.ɵɵrepeater(ctx.chartDataOptionSections());
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(13, _c4, ctx.zIndexValue));
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.isChartExpand ? 23 : -1);
        }
      },
      dependencies: [CommonModule, i1.NgClass, i1.NgStyle, ComponentsGlobalWebModule, i2.GDropDown, ReactiveFormsModule, i3.NgSelectOption, i3.ɵNgSelectMultipleOption, i3.SelectControlValueAccessor, i3.NgControlStatus, i3.FormControlDirective, IconComponent],
      styles: [".icon.size-small[_ngcontent-%COMP%]{width:.875rem;height:.875rem}.icon.size-standard[_ngcontent-%COMP%]{width:1.125rem;height:1.125rem}.icon.size-large[_ngcontent-%COMP%]{width:1.75rem;height:1.75rem}.icon.color-black[_ngcontent-%COMP%]{color:#000}.icon.color-red[_ngcontent-%COMP%]{color:#920000}.icon.color-green[_ngcontent-%COMP%]{color:#4bb450}.icon.color-yellow[_ngcontent-%COMP%]{color:#ffaf33}.icon.color-garmin-blue[_ngcontent-%COMP%]{color:#106fad}.icon.color-dark-gray[_ngcontent-%COMP%]{color:#737373}.icon.effect-hover[_ngcontent-%COMP%]{opacity:0;transition:opacity .2s}.icon.effect-hover[_ngcontent-%COMP%]:hover, .icon.effect-hover[_ngcontent-%COMP%]:focus-visible{opacity:1}.icon.prop-clickable[_ngcontent-%COMP%]{cursor:pointer}.chart-wrapper[_ngcontent-%COMP%]{height:20rem}.chart-wrapper[_ngcontent-%COMP%]{position:relative;overflow:hidden}.chart-wrapper-expanded[_ngcontent-%COMP%]{height:80vh;width:100vw;padding:4rem;margin-left:1.5rem}canvas[_ngcontent-%COMP%]{background-color:#fff}.icon[_ngcontent-%COMP%]{color:#000}.expand-button[_ngcontent-%COMP%]{float:right;margin-right:.5rem}.expand-chart[_ngcontent-%COMP%]{background-color:#fff}@media (max-width: 768px){.expand-button[_ngcontent-%COMP%]{display:none}}.data-selection-container[_ngcontent-%COMP%]{display:flex;justify-content:space-between;column-gap:2rem;margin-top:1rem;margin-left:1rem;margin-right:1rem}.inverse-expand-button[_ngcontent-%COMP%]{margin-top:5.3rem;margin-right:.3rem}"]
    });
  }
  return LogDetailsChartComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AircraftLogDetailsService = /*#__PURE__*/(() => {
  class AircraftLogDetailsService {
    aircraft = signal({
      aircraftUuid: '',
      model: {},
      tailNumber: '',
      sanitizedTailNumber: '',
      year: 0
    });
    flightLog = signal({
      id: '',
      aircraftDataDomainIntervalId: '',
      masterAircraftId: '',
      version: '',
      timeStart: '',
      timeEnd: ''
    });
    static ɵfac = function AircraftLogDetailsService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AircraftLogDetailsService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AircraftLogDetailsService,
      factory: AircraftLogDetailsService.ɵfac,
      providedIn: 'root'
    });
  }
  return AircraftLogDetailsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LogDetailsMapComponent = /*#__PURE__*/(() => {
  class LogDetailsMapComponent {
    map;
    document = inject(DOCUMENT);
    aircraftLogDetailsService = inject(AircraftLogDetailsService);
    mapService = inject(AvcMapsDisplayService);
    aircraftFlightLogPlaybackService = inject(AircraftFlightLogPlaybackService);
    zIndexService = inject(ZIndexService);
    isMapExpand = false;
    zIndexValue = 0;
    vfrView = true;
    constructor() {
      toObservable(this.currentTimestampDate).pipe(takeUntilDestroyed()).subscribe(timeStampDate => {
        if (this.mapService.animation.date().getTime() != timeStampDate.getTime()) {
          this.mapService.animation.seek(timeStampDate);
        }
      });
      toObservable(this.currentlyDisplayedIndex).pipe(takeUntilDestroyed()).subscribe(currentIndex => {
        if (currentIndex >= 0 && this.aircraftFlightLogPlaybackService.currentIndex() != currentIndex) {
          this.aircraftFlightLogPlaybackService.currentIndex.set(currentIndex);
        }
      });
    }
    ngOnInit() {
      this.zIndexValue = this.zIndexService.nextZIndex();
    }
    ngAfterViewInit() {
      this.mapService.attachMap(this.map.nativeElement);
      this.onClickGarminVfr();
      this.populateFlight();
    }
    onClickGarminVfr() {
      this.vfrView = true;
      this.mapService.preset.apply(MapPreset.VFR);
      this.mapService.theme.apply(MapThemePreset.Topography);
      this.mapService.settings.activeMapLayer.set(MapOverlayLayer.VFR);
      this.mapService.settings.vfrTopographyState.set(TopographyState.ON);
    }
    onClickSatellite() {
      this.vfrView = false;
      this.mapService.preset.apply(MapPreset.Satellite);
      this.mapService.theme.apply(MapThemePreset.Satellite);
      this.mapService.settings.activeMapLayer.set(MapOverlayLayer.Satellite);
    }
    populateFlight() {
      const mapDataPoints = this.aircraftFlightLogPlaybackService.flightLogData().filter(flightRow => flightRow.latitudePosition != null && flightRow.longitudePosition != null).map(flightLogRow => {
        return {
          latitude: flightLogRow.latitudePosition ?? Number.NaN,
          longitude: flightLogRow.longitudePosition ?? Number.NaN,
          timestamp: Math.floor(new Date(flightLogRow.timestamp).getTime() / 1000)
        };
      });
      const flight = {
        id: this.aircraftLogDetailsService.flightLog().id,
        aircraftModel: this.aircraftLogDetailsService.aircraft().model?.name,
        color: 'magenta',
        borderColor: 'white',
        points: mapDataPoints,
        aircraftIconScaling: {
          minZoom: 0.125,
          minScale: 0.125,
          maxZoom: 0.25,
          maxScale: 0.125
        }
      };
      this.mapService.data.flights.set([flight]);
      this.mapService.state.fit({
        elements: [flight],
        padding: 1.1
      });
    }
    currentlyDisplayedIndex = computed(() => {
      const currentDisplayedTimestamp = this.mapService.animation.date();
      const currentIndex = this.aircraftFlightLogPlaybackService.currentIndex();
      const flightLogData = this.aircraftFlightLogPlaybackService.flightLogData();
      if (new Date(flightLogData[currentIndex].timestamp).getTime() != currentDisplayedTimestamp.getTime()) {
        return flightLogData.findIndex(row => new Date(row.timestamp).getTime() == currentDisplayedTimestamp.getTime());
      } else {
        return currentIndex;
      }
    });
    currentTimestampDate = computed(() => {
      const flightLogData = this.aircraftFlightLogPlaybackService.flightLogData();
      return new Date(flightLogData[this.aircraftFlightLogPlaybackService.currentIndex()].timestamp);
    });
    toggleMapExpand() {
      const mapComponent = this.map.nativeElement;
      if (this.isMapExpand) {
        if (this.document.exitFullscreen != null) {
          this.document.exitFullscreen().catch(err => console.error('Failed to exit fullscreen:', err));
          this.isMapExpand = false;
        }
      } else {
        if (mapComponent.requestFullscreen != null) {
          mapComponent.requestFullscreen().catch(err => console.error('Failed to enter fullscreen:', err));
          this.isMapExpand = true;
        }
      }
    }
    onEscapeKey() {
      if (this.document.fullscreenElement == null) {
        this.isMapExpand = false;
      }
    }
    static ɵfac = function LogDetailsMapComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LogDetailsMapComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: LogDetailsMapComponent,
      selectors: [["aclogbook-log-details-map"]],
      viewQuery: function LogDetailsMapComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c5, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.map = _t.first);
        }
      },
      hostBindings: function LogDetailsMapComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("fullscreenchange", function LogDetailsMapComponent_fullscreenchange_HostBindingHandler($event) {
            return ctx.onEscapeKey($event);
          }, false, i0.ɵɵresolveDocument);
        }
      },
      decls: 11,
      vars: 9,
      consts: [["map", ""], [1, "map", 3, "ngStyle"], [1, "controllers", 3, "ngStyle"], [1, "controls"], ["size", "small", 1, "vfr-button", 3, "click", "theme"], ["size", "small", 3, "click", "theme"], [1, "two-arrows-fullscreen", 3, "click"], ["icon", "fullscreen-arrow-up-right-down-left", 1, "icon", "size-small", "two-arrows"], ["icon", "inverse-fullscreen-arrow-inwards-up-right-down-left", 1, "icon", "size-small", "two-arrows"]],
      template: function LogDetailsMapComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 1, 0)(2, "div", 2)(3, "div", 3)(4, "g-button", 4);
          i0.ɵɵlistener("click", function LogDetailsMapComponent_Template_g_button_click_4_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onClickGarminVfr());
          });
          i0.ɵɵtext(5, "Garmin VFR");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(6, "g-button", 5);
          i0.ɵɵlistener("click", function LogDetailsMapComponent_Template_g_button_click_6_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onClickSatellite());
          });
          i0.ɵɵtext(7, "Satellite");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(8, "button", 6);
          i0.ɵɵlistener("click", function LogDetailsMapComponent_Template_button_click_8_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.toggleMapExpand());
          });
          i0.ɵɵtemplate(9, LogDetailsMapComponent_Conditional_9_Template, 1, 0, "fly-icon", 7)(10, LogDetailsMapComponent_Conditional_10_Template, 1, 0, "fly-icon", 8);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(5, _c4, ctx.zIndexValue));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(7, _c4, ctx.zIndexValue));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("theme", ctx.vfrView ? "black" : "white");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("theme", ctx.vfrView ? "white" : "black");
          i0.ɵɵadvance(3);
          i0.ɵɵconditional(!ctx.isMapExpand ? 9 : 10);
        }
      },
      dependencies: [AvcMapsDisplayModule, CommonModule, i1.NgStyle, ComponentsGlobalWebModule, i2.GButton, IconComponent],
      styles: [".icon.size-small[_ngcontent-%COMP%]{width:.875rem;height:.875rem}.icon.size-standard[_ngcontent-%COMP%]{width:1.125rem;height:1.125rem}.icon.size-large[_ngcontent-%COMP%]{width:1.75rem;height:1.75rem}.icon.color-black[_ngcontent-%COMP%]{color:#000}.icon.color-red[_ngcontent-%COMP%]{color:#920000}.icon.color-green[_ngcontent-%COMP%]{color:#4bb450}.icon.color-yellow[_ngcontent-%COMP%]{color:#ffaf33}.icon.color-garmin-blue[_ngcontent-%COMP%]{color:#106fad}.icon.color-dark-gray[_ngcontent-%COMP%]{color:#737373}.icon.effect-hover[_ngcontent-%COMP%]{opacity:0;transition:opacity .2s}.icon.effect-hover[_ngcontent-%COMP%]:hover, .icon.effect-hover[_ngcontent-%COMP%]:focus-visible{opacity:1}.icon.prop-clickable[_ngcontent-%COMP%]{cursor:pointer}.map[_ngcontent-%COMP%]{height:20rem}.controllers[_ngcontent-%COMP%]{display:flex;flex-direction:row;position:absolute;bottom:0rem;right:0rem;background-color:#fff;width:auto;height:auto;justify-content:center;align-items:center}.controls[_ngcontent-%COMP%]{margin-right:5px;margin-left:8px;margin-top:5px}.vfr-button[_ngcontent-%COMP%]{margin-right:5px}.two-arrows-fullscreen[_ngcontent-%COMP%]{margin-top:4px}.four-arrows-fullscreen[_ngcontent-%COMP%]{margin-left:1rem}.icon.size-small.two-arrows[_ngcontent-%COMP%]{color:#000;margin-right:.7rem;margin-left:.9rem}.icon.size-small[_ngcontent-%COMP%]{margin-top:.1rem;margin-bottom:.025rem}@media (max-width: 768px){.two-arrows-fullscreen[_ngcontent-%COMP%]{display:none}}"]
    });
  }
  return LogDetailsMapComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AircraftLogDetailsPlaybackComponent = /*#__PURE__*/(() => {
  class AircraftLogDetailsPlaybackComponent {
    fullscreenContent;
    logbookEntryUuid;
    aircraftFlightLogService = inject(AircraftFlightLogService);
    aircraftFlightLogPlaybackService = inject(AircraftFlightLogPlaybackService);
    document = inject(DOCUMENT);
    currentState = signal('LOADING');
    isFullscreen = false;
    ngOnInit() {
      this.aircraftFlightLogService.getFlightLogFile(this.logbookEntryUuid).subscribe({
        next: flightLogData => {
          this.aircraftFlightLogPlaybackService.flightLogData.set(flightLogData);
          this.currentState.set('LOADED');
        },
        error: error => {
          console.error(error);
          this.currentState.set('ERROR');
        }
      });
    }
    ngAfterViewInit() {
      if (this.fullscreenContent == null) {
        throw new Error('HTML element is unexpectedly null');
      }
    }
    toggleFullscreen() {
      const fullscreenComponent = this.fullscreenContent?.nativeElement;
      if (this.isFullscreen) {
        if (this.document.exitFullscreen != null) {
          this.document.exitFullscreen().catch(err => console.error('Failed to exit fullscreen:', err));
          this.isFullscreen = false;
        }
      } else {
        if (fullscreenComponent.requestFullscreen != null) {
          fullscreenComponent.requestFullscreen().catch(err => console.error('Failed to enter fullscreen:', err));
          this.isFullscreen = true;
        }
      }
    }
    onEscapeKey() {
      if (this.document.fullscreenElement == null) {
        this.isFullscreen = false;
      }
    }
    static ɵfac = function AircraftLogDetailsPlaybackComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AircraftLogDetailsPlaybackComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AircraftLogDetailsPlaybackComponent,
      selectors: [["aclogbook-aircraft-log-details-playback"]],
      viewQuery: function AircraftLogDetailsPlaybackComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c6, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fullscreenContent = _t.first);
        }
      },
      hostBindings: function AircraftLogDetailsPlaybackComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("fullscreenchange", function AircraftLogDetailsPlaybackComponent_fullscreenchange_HostBindingHandler($event) {
            return ctx.onEscapeKey($event);
          }, false, i0.ɵɵresolveDocument);
        }
      },
      inputs: {
        logbookEntryUuid: "logbookEntryUuid"
      },
      features: [i0.ɵɵProvidersFeature([], [AircraftFlightLogPlaybackService, LogDetailsChartService])],
      decls: 5,
      vars: 2,
      consts: [["fullscreenContent", ""], [3, "ngClass"], [1, "map-chart-loader"], [1, "playback-loader"], [1, "controls-container"], [1, "fullscreen-button", 3, "click"], ["icon", "fullscreen-four-arrows-outward", 1, "icon", "size-small"], ["icon", "inverse-fullscreen-four-arrows-inwards", 1, "icon", "size-small", "four-arrows"]],
      template: function AircraftLogDetailsPlaybackComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 1, 0);
          i0.ɵɵtemplate(2, AircraftLogDetailsPlaybackComponent_Case_2_Template, 3, 0)(3, AircraftLogDetailsPlaybackComponent_Case_3_Template, 7, 2)(4, AircraftLogDetailsPlaybackComponent_Case_4_Template, 2, 0, "p");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          let tmp_2_0;
          i0.ɵɵproperty("ngClass", ctx.isFullscreen ? "interactive-container-fullscreen" : "interactive-container");
          i0.ɵɵadvance(2);
          i0.ɵɵconditional((tmp_2_0 = ctx.currentState()) === "LOADING" ? 2 : tmp_2_0 === "LOADED" ? 3 : tmp_2_0 === "ERROR" ? 4 : -1);
        }
      },
      dependencies: [CommonModule, i1.NgClass, LogDetailsChartComponent, LogDetailsMapComponent, AircraftFlightLogPlaybackControlsComponent, ComponentsGlobalWebModule, i2.GSkeleton, IconComponent],
      styles: [".map-chart-loader[_ngcontent-%COMP%]{height:20rem}.interactive-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;gap:2rem;background-color:#fff;justify-content:space-between}.interactive-container-fullscreen[_ngcontent-%COMP%]{display:flex;flex-direction:column;background-color:#fff;gap:2rem;justify-content:space-evenly;padding:0 2rem}.playback-loader[_ngcontent-%COMP%]{height:4rem}.controls-container[_ngcontent-%COMP%]{display:flex}aclogbook-aircraft-flight-log-playback-controls[_ngcontent-%COMP%]{width:100%}aclogbook-log-details-chart[_ngcontent-%COMP%]{height:25rem}.chart[_ngcontent-%COMP%]{width:100%}.chart-fullscreen[_ngcontent-%COMP%]{padding:0 2rem}button[_ngcontent-%COMP%]{margin-top:1.5rem;width:1rem;height:1rem;margin-right:.8rem}@media (max-width: 768px){.fullscreen-button[_ngcontent-%COMP%]{display:none}}"]
    });
  }
  return AircraftLogDetailsPlaybackComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Returns the decimal representation of the flight duration.
 * It's fairly standard to use a single decimal point in a logbook but a second was added just in case.
 */
let FormattedFlightLogResponseDurationPipe = /*#__PURE__*/(() => {
  class FormattedFlightLogResponseDurationPipe {
    transform(flightLog) {
      const startTime = new Date(flightLog.timeStart);
      const endTime = new Date(flightLog.timeEnd);
      // endTime.getTime() - startTime.getTime() gives us the duration in milliseconds and there are 3600000 milliseconds in an hour.
      const elapsedHours = (endTime.getTime() - startTime.getTime()) / 3600000;
      // Round to two decimal points
      return elapsedHours.toFixed(2);
    }
    static ɵfac = function FormattedFlightLogResponseDurationPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormattedFlightLogResponseDurationPipe)();
    };
    static ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "aclogbookFormattedFlightLogResponseDuration",
      type: FormattedFlightLogResponseDurationPipe,
      pure: true
    });
  }
  return FormattedFlightLogResponseDurationPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormattedFlightLogResponseStartTimePipe = /*#__PURE__*/(() => {
  class FormattedFlightLogResponseStartTimePipe {
    transform(flightLog) {
      // Formats time using the Zulu timezone and 24 hour time such that a sample output is '23:10:30 UTC'
      const timeFormat = new Intl.DateTimeFormat('en', {
        timeStyle: 'long',
        hour12: false,
        timeZone: 'UTC'
      });
      return timeFormat.format(new Date(flightLog.timeStart));
    }
    static ɵfac = function FormattedFlightLogResponseStartTimePipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormattedFlightLogResponseStartTimePipe)();
    };
    static ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "aclogbookFormattedFlightLogResponseStartTime",
      type: FormattedFlightLogResponseStartTimePipe,
      pure: true
    });
  }
  return FormattedFlightLogResponseStartTimePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AircraftLogSummaryComponent = /*#__PURE__*/(() => {
  class AircraftLogSummaryComponent {
    aircraftLogDetailsService = inject(AircraftLogDetailsService);
    static ɵfac = function AircraftLogSummaryComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AircraftLogSummaryComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AircraftLogSummaryComponent,
      selectors: [["aclogbook-aircraft-log-summary"]],
      decls: 29,
      vars: 10,
      consts: [[3, "ngClass"], [1, "section"], [1, "row"], [1, "column"], [1, "label"], [1, "value"], [1, "section-divider"], [1, "engine-section"], [1, "engine_label"], [1, "text-color"], [1, "nA-text"], [1, "engine"]],
      template: function AircraftLogSummaryComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h3");
          i0.ɵɵtext(3, "SUMMARY");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(4, "div", 2)(5, "div", 3)(6, "span", 4);
          i0.ɵɵtext(7, "Date");
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(8, AircraftLogSummaryComponent_Conditional_8_Template, 3, 5, "span", 5);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(9, "div", 3)(10, "span", 4);
          i0.ɵɵtext(11, "Aircraft");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(12, "span", 5);
          i0.ɵɵtext(13);
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(14, "div", 2)(15, "div", 3)(16, "span", 4);
          i0.ɵɵtext(17, "Departure Time");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(18, "span", 5);
          i0.ɵɵtext(19);
          i0.ɵɵpipe(20, "aclogbookFormattedFlightLogResponseStartTime");
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(21, "div", 2)(22, "div", 3)(23, "span", 4);
          i0.ɵɵtext(24, "Total Time");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(25, "span", 5);
          i0.ɵɵtext(26);
          i0.ɵɵpipe(27, "aclogbookFormattedFlightLogResponseDuration");
          i0.ɵɵelementEnd()()()();
          i0.ɵɵtemplate(28, AircraftLogSummaryComponent_Conditional_28_Template, 20, 4);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", ctx.aircraftLogDetailsService.flightLog().hobbsTimeStart ? "container" : "short-container");
          i0.ɵɵadvance(8);
          i0.ɵɵconditional(ctx.aircraftLogDetailsService.flightLog().timeStart != null ? 8 : -1);
          i0.ɵɵadvance(5);
          i0.ɵɵtextInterpolate(ctx.aircraftLogDetailsService.aircraft().tailNumber);
          i0.ɵɵadvance(6);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(20, 6, ctx.aircraftLogDetailsService.flightLog()));
          i0.ɵɵadvance(7);
          i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(27, 8, ctx.aircraftLogDetailsService.flightLog()), " hrs");
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.aircraftLogDetailsService.flightLog().hobbsTimeStart != null ? 28 : -1);
        }
      },
      dependencies: [CommonModule, i1.NgClass, i1.DecimalPipe, ComponentsGlobalWebModule, FormattedDatePipe, FormattedFlightLogResponseDurationPipe, FormattedFlightLogResponseStartTimePipe],
      styles: [".container[_ngcontent-%COMP%]{border:1px solid #eee;height:100%;box-shadow:0 1px 1px #4d4d4d14,0 1px 3px 1px #4d4d4d29;background-color:#fff;padding:1rem 1.5rem}.short-container[_ngcontent-%COMP%]{border:1px solid #eee;height:max-content;box-shadow:0 1px 1px #4d4d4d14,0 1px 3px 1px #4d4d4d29;background-color:#fff;padding:1rem 1.5rem}.row[_ngcontent-%COMP%]{display:flex;justify-content:space-between;margin-bottom:.625rem}.column[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex:1}.value[_ngcontent-%COMP%], .engine_label[_ngcontent-%COMP%]{font-weight:700}.text-color[_ngcontent-%COMP%]{color:gray}.nA-text[_ngcontent-%COMP%]{color:#000;font-weight:700}hr.section-divider[_ngcontent-%COMP%]{height:.0625rem;background-color:#d9d9d9;margin:.5rem 0}hr.engine[_ngcontent-%COMP%]{height:.0625rem;background-color:#d9d9d9;margin-bottom:.5rem;margin-top:.5rem;width:70%}"]
    });
  }
  return AircraftLogSummaryComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AircraftLogDetailsComponent = /*#__PURE__*/(() => {
  class AircraftLogDetailsComponent {
    aircraftReadService = inject(AircraftReadService);
    aircraftFlightLogService = inject(AircraftFlightLogService);
    route = inject(ActivatedRoute);
    aircraftLogDetailsService = inject(AircraftLogDetailsService);
    config = inject(FLY_WEB_COMMON_CONFIG);
    aircraftUuid = this.route.snapshot.params['aircraftUuid'];
    logbookEntryUuid = this.route.snapshot.params['logbookEntryUuid'];
    currentState = 'LOADING';
    showLogbookUrl = false;
    ngOnInit() {
      if (this.config.site === 'FGA') {
        this.showLogbookUrl = true;
      }
      if (this.aircraftUuid == null || this.logbookEntryUuid == null) {
        throw new Error('Aircraft uuid and logbook entry uuid must be provided');
      }
      forkJoin([this.aircraftReadService.getAircraftByAircraftUuid(this.aircraftUuid), this.aircraftFlightLogService.getFlightLog(this.logbookEntryUuid)]).subscribe({
        next: ([aircraft, flightLog]) => {
          this.aircraftLogDetailsService.aircraft.set(aircraft);
          this.aircraftLogDetailsService.flightLog.set(flightLog);
          this.currentState = 'LOADED';
        },
        error: error => {
          console.error(error);
          this.currentState = 'ERROR';
        }
      });
    }
    downloadLogAsCsv() {
      this.aircraftFlightLogService.getFlightLogCsv(this.logbookEntryUuid).subscribe(blob => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        const tailNumber = this.aircraftLogDetailsService.aircraft().tailNumber;
        const startTime = this.aircraftLogDetailsService.flightLog().timeStart;
        a.href = url;
        if (tailNumber != null && startTime != null) {
          // : aren't allowed in the file name so they're removed and the milliseconds are removed from the end of the csv using slice
          a.download = `aircraft-log-${tailNumber}-${startTime.replaceAll(':', '').slice(0, startTime.length - 7)}.csv`;
        } else {
          a.download = `aircraft-log-${new Date().toISOString}.csv`;
        }
        a.click();
        URL.revokeObjectURL(url);
      });
    }
    static ɵfac = function AircraftLogDetailsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AircraftLogDetailsComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AircraftLogDetailsComponent,
      selectors: [["aclogbook-aircraft-log-details"]],
      decls: 3,
      vars: 1,
      consts: [["type", "dark"], [1, "header-container"], [1, "breadcrumb-container"], ["role", "navigation"], [3, "routerLink"], [3, "text"], [1, "desktop-download-button"], ["theme", "light", "label", "Download log as CSV", 3, "click"], [1, "page-content-container"], [1, "log-summary"], [1, "mobile-download-button"], ["theme", "light", "label", "Download log as CSV", 1, "g-button-full-width", 3, "click"], [1, "interactive-content-container", 3, "logbookEntryUuid"]],
      template: function AircraftLogDetailsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, AircraftLogDetailsComponent_Conditional_0_Template, 1, 0, "g-loader", 0)(1, AircraftLogDetailsComponent_Conditional_1_Template, 25, 16)(2, AircraftLogDetailsComponent_Conditional_2_Template, 4, 0);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.currentState === "LOADING" ? 0 : ctx.currentState === "LOADED" ? 1 : 2);
        }
      },
      dependencies: [AircraftLogSummaryComponent, AircraftLogDetailsPlaybackComponent, AvcMapsDisplayModule, ComponentsGlobalWebModule, i2.GBreadcrumb, i2.GBreadcrumbs, i2.GButton, i2.GLoader, FormattedDatePipe, RouterModule, i2$1.RouterLink],
      styles: [".icon.size-small[_ngcontent-%COMP%]{width:.875rem;height:.875rem}.icon.size-standard[_ngcontent-%COMP%]{width:1.125rem;height:1.125rem}.icon.size-large[_ngcontent-%COMP%]{width:1.75rem;height:1.75rem}.icon.color-black[_ngcontent-%COMP%]{color:#000}.icon.color-red[_ngcontent-%COMP%]{color:#920000}.icon.color-green[_ngcontent-%COMP%]{color:#4bb450}.icon.color-yellow[_ngcontent-%COMP%]{color:#ffaf33}.icon.color-garmin-blue[_ngcontent-%COMP%]{color:#106fad}.icon.color-dark-gray[_ngcontent-%COMP%]{color:#737373}.icon.effect-hover[_ngcontent-%COMP%]{opacity:0;transition:opacity .2s}.icon.effect-hover[_ngcontent-%COMP%]:hover, .icon.effect-hover[_ngcontent-%COMP%]:focus-visible{opacity:1}.icon.prop-clickable[_ngcontent-%COMP%]{cursor:pointer}[_nghost-%COMP%]{display:flex;flex-direction:column;padding:1rem;margin:1rem}h1[_ngcontent-%COMP%]{text-align:center}@media screen and (min-width: 768px){h1[_ngcontent-%COMP%]{text-align:start}}.breadcrumb[_ngcontent-%COMP%]{justify-content:flex-start}@media screen and (min-width: 768px){.breadcrumb[_ngcontent-%COMP%]{justify-content:center}}.breadcrumb-container[_ngcontent-%COMP%]{display:flex;margin-bottom:0}.log-summary[_ngcontent-%COMP%]{flex:0 0 30%}.interactive-content-container[_ngcontent-%COMP%]{flex:1;overflow:hidden}.page-content-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:space-between;gap:2rem}@media screen and (min-width: 768px){.page-content-container[_ngcontent-%COMP%]{flex-direction:row}}.desktop-download-button[_ngcontent-%COMP%]{display:none}@media screen and (min-width: 768px){.desktop-download-button[_ngcontent-%COMP%]{display:flex;align-items:flex-end}}@media screen and (min-width: 768px){.mobile-download-button[_ngcontent-%COMP%]{display:none}}.g-button-full-width[_ngcontent-%COMP%], .g-button-full-width[_ngcontent-%COMP%]   .g__button__host[_ngcontent-%COMP%]{width:100%}.header-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:space-between;gap:2rem;margin-bottom:1.25rem}@media screen and (min-width: 768px){.header-container[_ngcontent-%COMP%]{flex-direction:row;align-items:flex-end;margin-bottom:2rem}}"]
    });
  }
  return AircraftLogDetailsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const PAGE_URLS = {
  GDL_60_MARKETING_URL: 'https://www.garmin.com/p/664160/',
  FAQ_URL: 'https://support.garmin.com/aviation/faq/XKZPueBGDx7Tsy0w8yfBU9/',
  LEARN_MORE_URL: 'https://support.garmin.com/aviation/faq/f27h7lf4f58FRBgqa22zr8/'
};
let AircraftFlightLogPagingService = /*#__PURE__*/(() => {
  class AircraftFlightLogPagingService {
    currentPage = signal(null);
    hasError = signal(false);
    isLoading = signal(false);
    get lastModifiedDate$() {
      return this._lastModifiedDate$.pipe(distinct());
    }
    flightsPerPage = 20;
    currentPageNumber = 0;
    startDate;
    endDate;
    sortOrder = 'desc';
    masterAircraftId = null;
    aircraftLogbookService = inject(AircraftFlightLogService);
    destroyRef = inject(DestroyRef);
    _lastModifiedDate$ = new Subject();
    ngOnDestroy() {
      this._lastModifiedDate$.complete();
    }
    nextPage() {
      const currentPage = this.currentPage();
      if (currentPage == null || this.currentPageNumber === currentPage.page.totalPages - 1) {
        throw new Error(`Unable to increment page. This is the last page. Current value: ${this.currentPageNumber}`);
      }
      this.currentPageNumber = this.currentPageNumber + 1;
      this.updateContent();
    }
    previousPage() {
      if (this.currentPageNumber === 0) {
        throw new Error(`Unable to go to previous page if current page is 0. Current value: ${this.currentPageNumber}`);
      }
      this.currentPageNumber = this.currentPageNumber - 1;
      this.updateContent();
    }
    setPage(pageNumber) {
      if (pageNumber < 0 || pageNumber >= (this.currentPage()?.page.totalPages ?? 0)) {
        throw new Error(`Unable to set page to ${pageNumber}. Out of bounds.`);
      }
      this.currentPageNumber = pageNumber;
      this.updateContent();
    }
    setFlightsPerPage(flightsPerPage) {
      if (flightsPerPage <= 0 || flightsPerPage > 100) {
        throw new Error(`Flights per page must be between 0 and 100. Provided value: ${flightsPerPage}`);
      }
      this.flightsPerPage = flightsPerPage;
      this.reset();
    }
    getFlightsPerPage() {
      return this.flightsPerPage;
    }
    setSortOrder(sortOrder) {
      this.sortOrder = sortOrder;
      this.reset();
    }
    getSortOrder() {
      return this.sortOrder;
    }
    setMasterAircraftId(masterAircraftId) {
      this.masterAircraftId = masterAircraftId;
      this.reset();
    }
    setStartDate(startDate) {
      this.startDate = startDate;
      this.updateContent();
    }
    setEndDate(endDate) {
      this.endDate = endDate;
      this.updateContent();
    }
    reset() {
      this.currentPageNumber = 0;
      this.updateContent();
    }
    updateContent() {
      if (this.masterAircraftId == null) {
        throw new Error('MasterAircraftId must be set prior to performing any operations.');
      }
      if (this.isLoading()) {
        throw new Error('Not able to perform multiple operations at once. Wait for loading to finish.');
      }
      this.hasError.set(false);
      this.isLoading.set(true);
      this.aircraftLogbookService.getFlightLogsByAircraft({
        masterAircraftId: this.masterAircraftId,
        timeStartAfter: this.startDate,
        timeStartBefore: this.endDate,
        pageNumber: this.currentPageNumber,
        pageSize: this.flightsPerPage,
        sortOrder: this.sortOrder
      }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        next: response => {
          this.isLoading.set(false);
          this.currentPage.set(response);
          this._lastModifiedDate$.next(response.lastModifiedDate);
        },
        error: e => {
          console.error(e);
          this.isLoading.set(false);
          this.currentPage.set(null);
          this.hasError.set(true);
        }
      });
    }
    static ɵfac = function AircraftFlightLogPagingService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AircraftFlightLogPagingService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AircraftFlightLogPagingService,
      factory: AircraftFlightLogPagingService.ɵfac
    });
  }
  return AircraftFlightLogPagingService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var LogTableHeaders = /*#__PURE__*/function (LogTableHeaders) {
  LogTableHeaders["DATE"] = "Date";
  LogTableHeaders["TIME"] = "Time";
  LogTableHeaders["DURATION"] = "Duration (hr)";
  LogTableHeaders["HOBBS"] = "Hobbs Start/End";
  LogTableHeaders["TACH"] = "Tach Start/End";
  LogTableHeaders["TACH1"] = "Tach 1 Start/End";
  LogTableHeaders["TACH2"] = "Tach 2 Start/End";
  LogTableHeaders["DOWNLOAD"] = "Download";
  return LogTableHeaders;
}(LogTableHeaders || {});
let LogRowComponent = /*#__PURE__*/(() => {
  class LogRowComponent {
    logRow;
    headers;
    flightLogId;
    tailNumber;
    LogTableHeaders = LogTableHeaders;
    aircraftFlightLogService = inject(AircraftFlightLogService);
    // The below method needs to be refactored if the change detection is changed from OnPush
    shouldShowColumn(header) {
      return this.headers.includes(header);
    }
    downloadLogAsCsv(event) {
      event.stopPropagation();
      this.aircraftFlightLogService.getFlightLogCsv(this.flightLogId).subscribe(blob => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `aircraft-log-${this.tailNumber}-${this.logRow.timeStart.substring(0, 10)}.csv`;
        a.click();
        URL.revokeObjectURL(url);
      });
    }
    static ɵfac = function LogRowComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LogRowComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: LogRowComponent,
      selectors: [["", "aclogbook-log-row", ""]],
      inputs: {
        logRow: "logRow",
        headers: "headers",
        flightLogId: "flightLogId",
        tailNumber: "tailNumber"
      },
      attrs: _c9,
      decls: 8,
      vars: 8,
      consts: [[1, "duration"], [1, "desktop"], [1, "mobile"], [1, "desktop-tach"], ["title", "Download", "tabindex", "0", "aria-label", "Download Link", 1, "download-link", 3, "click"], ["icon", "download", 1, "icon", "size-standard"]],
      template: function LogRowComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, LogRowComponent_Conditional_0_Template, 9, 13)(1, LogRowComponent_Conditional_1_Template, 3, 3, "td")(2, LogRowComponent_Conditional_2_Template, 3, 3, "td", 0)(3, LogRowComponent_Conditional_3_Template, 2, 1)(4, LogRowComponent_Conditional_4_Template, 2, 1)(5, LogRowComponent_Conditional_5_Template, 2, 1)(6, LogRowComponent_Conditional_6_Template, 2, 1)(7, LogRowComponent_Conditional_7_Template, 3, 0, "td");
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.shouldShowColumn(ctx.LogTableHeaders.DATE) ? 0 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.shouldShowColumn(ctx.LogTableHeaders.TIME) ? 1 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.shouldShowColumn(ctx.LogTableHeaders.DURATION) ? 2 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.shouldShowColumn(ctx.LogTableHeaders.HOBBS) ? 3 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.shouldShowColumn(ctx.LogTableHeaders.TACH1) ? 4 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.shouldShowColumn(ctx.LogTableHeaders.TACH) ? 5 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.shouldShowColumn(ctx.LogTableHeaders.TACH2) ? 6 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.shouldShowColumn(ctx.LogTableHeaders.DOWNLOAD) ? 7 : -1);
        }
      },
      dependencies: [CommonModule, i1.DecimalPipe, ComponentsGlobalWebModule, FormattedDatePipe, FormattedFlightLogResponseDurationPipe, FormattedFlightLogResponseStartTimePipe, IconComponent],
      styles: ["td[_ngcontent-%COMP%]{vertical-align:middle;text-align:left}th[_ngcontent-%COMP%]{text-align:left;text-transform:uppercase}thead[_ngcontent-%COMP%]{border-bottom:solid 1px black}.icon.size-small[_ngcontent-%COMP%]{width:.875rem;height:.875rem}.icon.size-standard[_ngcontent-%COMP%]{width:1.125rem;height:1.125rem}.icon.size-large[_ngcontent-%COMP%]{width:1.75rem;height:1.75rem}.icon.color-black[_ngcontent-%COMP%]{color:#000}.icon.color-red[_ngcontent-%COMP%]{color:#920000}.icon.color-green[_ngcontent-%COMP%]{color:#4bb450}.icon.color-yellow[_ngcontent-%COMP%]{color:#ffaf33}.icon.color-garmin-blue[_ngcontent-%COMP%]{color:#106fad}.icon.color-dark-gray[_ngcontent-%COMP%]{color:#737373}.icon.effect-hover[_ngcontent-%COMP%]{opacity:0;transition:opacity .2s}.icon.effect-hover[_ngcontent-%COMP%]:hover, .icon.effect-hover[_ngcontent-%COMP%]:focus-visible{opacity:1}.icon.prop-clickable[_ngcontent-%COMP%]{cursor:pointer}.download-link[_ngcontent-%COMP%]{display:flex;padding:1rem;justify-content:center;border-radius:.25rem;align-items:center}.download-link[_ngcontent-%COMP%]:hover{background-color:#eee}.duration[_ngcontent-%COMP%]{text-align:start}.mobile[_ngcontent-%COMP%]{display:table-cell}@media screen and (min-width: 768px){.mobile[_ngcontent-%COMP%]{display:none}}.desktop-tach[_ngcontent-%COMP%]{display:none}@media screen and (min-width: 1024px){.desktop-tach[_ngcontent-%COMP%]{display:table-cell}}.desktop[_ngcontent-%COMP%]{display:none}@media screen and (min-width: 768px){.desktop[_ngcontent-%COMP%]{display:table-cell}}"],
      changeDetection: 0
    });
  }
  return LogRowComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LogTableComponent = /*#__PURE__*/(() => {
  class LogTableComponent {
    tailNumber;
    page = input();
    featuresService = inject(FeaturesService);
    LogTableHeaders = LogTableHeaders;
    mobileHeaders = [LogTableHeaders.DATE, LogTableHeaders.DURATION, LogTableHeaders.DOWNLOAD];
    entryDetailsEnabled = false;
    ngOnInit() {
      this.featuresService.isFeatureActive(FeatureFlyGarmin.AIRCRAFT_LOGBOOK_ENTRY_DETAILS).subscribe(enabled => this.entryDetailsEnabled = enabled);
    }
    logRows = computed(() => this.page()?.page.content ?? []);
    desktopHeaders = computed(() => {
      const logHeaders = [LogTableHeaders.DATE, LogTableHeaders.TIME, LogTableHeaders.DURATION];
      if (this.logRows().some(row => row.hobbsTimeStart != null || row.hobbsTimeEnd != null)) {
        logHeaders.push(LogTableHeaders.HOBBS);
      }
      if (this.logRows().some(row => row.tachTime1Start != null || row.tachTime1End != null)) {
        logHeaders.push(LogTableHeaders.TACH1);
      }
      if (this.logRows().some(row => row.tachTime2Start != null || row.tachTime2End != null)) {
        if (logHeaders.includes(LogTableHeaders.TACH1)) {
          logHeaders.push(LogTableHeaders.TACH2);
        } else {
          logHeaders.push(LogTableHeaders.TACH);
        }
      } else if (logHeaders.includes(LogTableHeaders.TACH1)) {
        logHeaders[logHeaders.indexOf(LogTableHeaders.TACH1)] = LogTableHeaders.TACH;
      }
      logHeaders.push(LogTableHeaders.DOWNLOAD);
      return logHeaders;
    });
    static ɵfac = function LogTableComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LogTableComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: LogTableComponent,
      selectors: [["aclogbook-log-table"]],
      inputs: {
        tailNumber: "tailNumber",
        page: [1, "page"]
      },
      decls: 16,
      vars: 0,
      consts: [[1, "desktop"], [3, "ngClass"], [1, "mobile"], ["aclogbook-log-row", "", "role", "link", 1, "clickable-row", 3, "routerLink", "logRow", "headers", "flightLogId", "tailNumber"], ["aclogbook-log-row", "", 1, "highlightable-row", 3, "logRow", "headers", "flightLogId", "tailNumber"]],
      template: function LogTableComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "table", 0)(1, "thead")(2, "tr");
          i0.ɵɵrepeaterCreate(3, LogTableComponent_For_4_Template, 2, 5, "th", 1, i0.ɵɵrepeaterTrackByIndex);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(5, "tbody");
          i0.ɵɵrepeaterCreate(6, LogTableComponent_For_7_Template, 2, 1, null, null, i0.ɵɵrepeaterTrackByIndex);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(8, "table", 2)(9, "thead")(10, "tr");
          i0.ɵɵrepeaterCreate(11, LogTableComponent_For_12_Template, 2, 4, "th", 1, i0.ɵɵrepeaterTrackByIndex);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(13, "tbody");
          i0.ɵɵrepeaterCreate(14, LogTableComponent_For_15_Template, 1, 7, "tr", 3, i0.ɵɵrepeaterTrackByIndex);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵrepeater(ctx.desktopHeaders());
          i0.ɵɵadvance(3);
          i0.ɵɵrepeater(ctx.logRows());
          i0.ɵɵadvance(5);
          i0.ɵɵrepeater(ctx.mobileHeaders);
          i0.ɵɵadvance(3);
          i0.ɵɵrepeater(ctx.logRows());
        }
      },
      dependencies: [CommonModule, i1.NgClass, LogRowComponent, RouterModule, i2$1.RouterLink],
      styles: ["td[_ngcontent-%COMP%]{vertical-align:middle;text-align:left}th[_ngcontent-%COMP%]{text-align:left;text-transform:uppercase}thead[_ngcontent-%COMP%]{border-bottom:solid 1px black}.clickable-row[_ngcontent-%COMP%]{cursor:pointer}.highlightable-row[_ngcontent-%COMP%]:hover:not(:has(a:hover)), .clickable-row[_ngcontent-%COMP%]:hover:not(:has(a:hover)){background-color:#eee}.mobile[_ngcontent-%COMP%]{display:table}@media screen and (min-width: 768px){.mobile[_ngcontent-%COMP%]{display:none}}.download[_ngcontent-%COMP%]{text-align:center}.desktop[_ngcontent-%COMP%]{display:none}@media screen and (min-width: 768px){.desktop[_ngcontent-%COMP%]{display:table}}.tach-header[_ngcontent-%COMP%]{display:none}@media screen and (min-width: 1024px){.tach-header[_ngcontent-%COMP%]{display:table-cell}}"],
      changeDetection: 0
    });
  }
  return LogTableComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MarketingComponent = /*#__PURE__*/(() => {
  class MarketingComponent {
    marketingUrl = PAGE_URLS.GDL_60_MARKETING_URL;
    static ɵfac = function MarketingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MarketingComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MarketingComponent,
      selectors: [["aclogbook-marketing"]],
      decls: 2,
      vars: 1,
      consts: [[3, "href"]],
      template: function MarketingComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "a", 0);
          i0.ɵɵtext(1, "Visit the GDL 60 page to learn more");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("href", ctx.marketingUrl, i0.ɵɵsanitizeUrl);
        }
      },
      encapsulation: 2
    });
  }
  return MarketingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AircraftLogbookEntriesComponent = /*#__PURE__*/(() => {
  class AircraftLogbookEntriesComponent {
    aircraft = null;
    showLogbookUrl = false;
    lastModifiedDate = null;
    newEntryDetected = false;
    faqUrl = PAGE_URLS.FAQ_URL;
    activatedRoute = inject(ActivatedRoute);
    aircraftReadService = inject(AircraftReadService);
    destroyRef = inject(DestroyRef);
    document = inject(DOCUMENT);
    router = inject(Router);
    featuresService = inject(FeaturesService);
    config = inject(FLY_WEB_COMMON_CONFIG);
    pagingService = inject(AircraftFlightLogPagingService);
    formGroup = new FormGroup({
      entriesPerPageControl: new FormControl(this.pagingService.getFlightsPerPage()),
      sortOrderControl: new FormControl(this.pagingService.getSortOrder()),
      startDate: new FormControl(''),
      endDate: new FormControl('')
    }, {
      validators: this.dateRangeValidator
    });
    currentState = signal('LOADING');
    flightsPerPageOptions = [20, 40, 60, 80, 100];
    numberOfPages = computed(() => this.pagingService.currentPage()?.page.totalPages ?? 0);
    moreThanOnePage = computed(() => this.numberOfPages() > 0);
    currentPage = computed(() => {
      const currPage = this.pagingService.currentPage()?.page.number;
      return currPage != null ? currPage + 1 : null;
    });
    numberOfFirstFlightOnPage = computed(() => (this.pagingService.currentPage()?.page.pageable.offset ?? 0) + 1);
    numberOfLastFlightOnPage = computed(() => this.numberOfFirstFlightOnPage() + this.numberOfFlightsOnPage() - 1);
    numberOfFlightsOnPage = computed(() => this.pagingService.currentPage()?.page.numberOfElements ?? 0);
    totalNumberOfFlights = computed(() => this.pagingService.currentPage()?.page.totalElements ?? 0);
    uploadLogsEnabled = false;
    shareLogsEnabled = false;
    ngOnInit() {
      if (this.config.site === 'FGA') {
        this.showLogbookUrl = true;
      }
      forkJoin([this.featuresService.isFeatureActive(this.config.site === 'FGA' ? FeatureFlyGarmin.AIRCRAFT_LOGBOOK_UPLOAD : FeatureFlyAdmin.ENABLE_AIRCRAFT_LOGBOOK_UPLOAD), this.featuresService.isFeatureActive(FeatureFlyGarmin.ENABLE_FLIGHT_LOG_SHARING)]).subscribe(([uploadLogsEnabled, shareLogsEnabled]) => {
        this.uploadLogsEnabled = uploadLogsEnabled;
        this.shareLogsEnabled = shareLogsEnabled;
      });
      this.activatedRoute.params.pipe(tap(() => this.currentState.set('LOADING')), filter(params => {
        const aircraftUuid = params['aircraftUuid'];
        if (aircraftUuid == null || !isValidUuid(aircraftUuid)) {
          this.currentState.set('ERROR');
          return false;
        }
        return true;
      }), map(params => {
        return params['aircraftUuid'];
      }), switchMap(aircraftUuid => this.aircraftReadService.getAircraftByAircraftUuid(aircraftUuid, true)), takeUntilDestroyed(this.destroyRef)).subscribe({
        next: aircraft => {
          if (aircraft.masterAircraftUuid != null) {
            this.aircraft = aircraft;
            this.pagingService.setMasterAircraftId(aircraft.masterAircraftUuid);
            this.currentState.set('LOADED');
          } else {
            this.currentState.set('ERROR');
          }
        },
        error: e => {
          console.error(e);
          this.currentState.set('ERROR');
        }
      });
      this.pagingService.lastModifiedDate$.pipe(skip(1)).subscribe(lastModifiedDate => {
        if (lastModifiedDate != this.lastModifiedDate) {
          this.lastModifiedDate = lastModifiedDate;
          this.newEntryDetected = true;
        } else {
          this.newEntryDetected = false;
        }
      });
      this.formGroup.controls.entriesPerPageControl.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(value => {
        if (value != null) {
          this.pagingService.setFlightsPerPage(value);
        }
      });
      this.formGroup.controls.sortOrderControl.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(value => {
        if (value != null) {
          this.pagingService.setSortOrder(value);
        }
      });
      this.formGroup.valueChanges.pipe(startWith(this.formGroup.value), pairwise(), takeUntilDestroyed(this.destroyRef)).subscribe(([previousValues, currentValues]) => {
        if (this.formGroup.valid) {
          if (currentValues.startDate !== previousValues.startDate && currentValues.startDate != null && isStringNonEmpty(currentValues.startDate)) {
            const startDate = new Date(currentValues.startDate);
            const startDateString = startDate.toISOString().replace('.000', '');
            this.pagingService.setStartDate(startDateString);
          } else if (currentValues.endDate !== previousValues.endDate && currentValues.endDate != null && isStringNonEmpty(currentValues.endDate)) {
            // 1 day is added because the API excludes the provided end date
            const endDate = addDays(new Date(currentValues.endDate), 1);
            const endDateString = endDate.toISOString().replace('.000', '');
            this.pagingService.setEndDate(endDateString);
          } else if (currentValues.startDate !== previousValues.startDate && currentValues.startDate === '') {
            this.pagingService.setStartDate(undefined);
          } else if (currentValues.startDate !== previousValues.startDate && currentValues.endDate === '') {
            this.pagingService.setEndDate(undefined);
          }
        }
      });
    }
    navigateToAircraftList() {
      this.document.location.href = `${FlyGarminLegacyBaseUrl[this.config.environment]}/devices/list`;
    }
    updatePage(pageEvent) {
      this.pagingService.setPage(pageEvent.detail - 1);
    }
    sharingLogPage() {
      let queryParams;
      if (this.config.site === 'FALA') {
        if (this.aircraft?.customerGuid != null) {
          queryParams = {
            customerGuid: this.aircraft.customerGuid
          };
        } else if (this.aircraft?.organizationUuid != null) {
          queryParams = {
            organizationUuid: this.aircraft.organizationUuid
          };
        }
      } else if (this.config.site !== 'FGA') {
        throw new Error(`Invalid site: ${this.config.site}`);
      }
      this.router.navigate(['/aircraft-logbook/sharing'], {
        queryParams
      });
    }
    dateRangeValidator(control) {
      const startDateControlName = 'startDate';
      const endDateControlName = 'endDate';
      if (!isStringNonEmpty(control.value[startDateControlName]) || !isStringNonEmpty(control.value[endDateControlName])) {
        return null;
      }
      const startDate = new Date(control.value[startDateControlName]);
      const endDate = new Date(control.value[endDateControlName]);
      return isBefore(startDate, endDate) ? null : {
        invalidDateRange: true
      };
    }
    static ɵfac = function AircraftLogbookEntriesComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AircraftLogbookEntriesComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AircraftLogbookEntriesComponent,
      selectors: [["aclogbook-aircraft-logbook-entries"]],
      features: [i0.ɵɵProvidersFeature([], [AircraftFlightLogPagingService])],
      decls: 6,
      vars: 1,
      consts: [["tableForm", ""], ["tableDisplay", ""], [1, "error-message"], [3, "routerLink"], ["type", "dark", 1, "loader"], [1, "breadcrumb-container"], ["stackMobile", "true"], ["role", "navigation"], [1, "breadcrumb"], [1, "breadcrumb", 3, "text"], [4, "ngTemplateOutlet"], ["type", "dark"], ["show", "true", "type", "info", "slotAlign", "center", 1, "new-entry-alert"], [1, "black"], [1, "no-log-found"], [1, "no-flights"], [1, "missing-flight2"], [1, "question-icon"], ["icon", "question-mark-circle", 1, "icon", "size-small"], [1, "faq-link"], ["target", "_blank", 3, "href"], ["show", "true", "type", "info", "slotAlign", "center", 1, "new-entry-alert", 3, "g-close"], [1, "table-form-controls"], ["label", "Sort By", 1, "table-form-control"], [3, "formControl"], ["key", "Newest to Oldest", "value", "desc"], ["key", "Oldest to Newest", "value", "asc"], ["label", "Flights per page", 1, "table-form-control"], [3, "value"], [1, "date-picker-wrapper", "table-form-control"], ["label", "Start Date", "label-for", "startDateInput", 3, "error"], ["type", "date", "id", "startDateInput", "aria-describedby", "startDateError", 3, "formControl"], ["id", "startDateError"], ["label", "End Date", "label-for", "endDateInput", 3, "error"], ["type", "date", "id", "endDateInput", "aria-describedby", "endDateError", 3, "formControl"], ["id", "endDateError"], [1, "upload-share-btns"], ["theme", "dark"], ["theme", "dark", 3, "click"], [1, "missing-flight"], [3, "page", "tailNumber"], [1, "pagination-details"], [1, "page-number"], ["ellipses", "true", "firstLastPageButtons", "false", "theme", "light", 3, "g-page-changed", "currentPage", "totalPages"]],
      template: function AircraftLogbookEntriesComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, AircraftLogbookEntriesComponent_Conditional_0_Template, 9, 3)(1, AircraftLogbookEntriesComponent_Conditional_1_Template, 2, 1)(2, AircraftLogbookEntriesComponent_ng_template_2_Template, 24, 10, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(4, AircraftLogbookEntriesComponent_ng_template_4_Template, 12, 8, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.currentState() === "ERROR" || ctx.pagingService.hasError() ? 0 : 1);
        }
      },
      dependencies: [CommonModule, i1.NgTemplateOutlet, ComponentsGlobalWebModule, i2.GAlert, i2.GBreadcrumb, i2.GBreadcrumbs, i2.GButton, i2.GDropDown, i2.GError, i2.GInput, i2.GLoader, i2.GPagination, IconComponent, LogTableComponent, MarketingComponent, ReactiveFormsModule, i3.NgSelectOption, i3.ɵNgSelectMultipleOption, i3.DefaultValueAccessor, i3.SelectControlValueAccessor, i3.NgControlStatus, i3.FormControlDirective, RouterModule, i2$1.RouterLink],
      styles: ["[_nghost-%COMP%]{margin:0;padding:1rem;display:block}@media screen and (min-width: 768px){[_nghost-%COMP%]{max-width:1200px;margin:0 auto}}.error-message[_ngcontent-%COMP%]{margin-top:1rem}.breadcrumb[_ngcontent-%COMP%]{justify-content:flex-start}@media screen and (min-width: 768px){.breadcrumb[_ngcontent-%COMP%]{justify-content:center}}.breadcrumb-container[_ngcontent-%COMP%]{display:flex;margin-bottom:1.25rem}@media screen and (min-width: 768px){.breadcrumb-container[_ngcontent-%COMP%]{margin-bottom:2rem}}hr[_ngcontent-%COMP%]{height:1px;background-color:#d9d9d9;margin-bottom:.5rem;margin-top:1.5rem;width:100%}.new-entry-alert[_ngcontent-%COMP%]{margin:1rem 0}.table-form-control[_ngcontent-%COMP%]{width:fit-content}.table-form-controls[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;gap:1rem;margin-bottom:1rem;margin-top:2rem}.table-form-controls[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{background-color:#fff;color:#000;cursor:pointer;transition:background-color .3s,color .3s;border:.1rem solid #000;border-radius:.2rem;padding:.5rem}.table-form-controls[_ngcontent-%COMP%]   button.active[_ngcontent-%COMP%]{background-color:#000;color:#fff}.table-form-controls[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:not(.active){background-color:#fff;color:#000}.table-form-controls[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:first-child{margin-right:.3rem}.page-number[_ngcontent-%COMP%]{font-weight:500}.pagination-details[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:start;flex-direction:column;gap:1rem;margin-top:.5rem}@media screen and (min-width: 768px){.pagination-details[_ngcontent-%COMP%]{flex-direction:row;align-items:center}}.invalid-aircraft[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1.25rem;margin:1rem 0}@media screen and (min-width: 768px){.invalid-aircraft[_ngcontent-%COMP%]{font-size:1.5rem}}.no-flights[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1rem;margin:1rem 0}@media screen and (min-width: 768px){.no-flights[_ngcontent-%COMP%]{font-size:1.25rem}}.no-log-found[_ngcontent-%COMP%]{margin-top:2rem;margin-bottom:2rem}.faq-link[_ngcontent-%COMP%]   span[_ngcontent-%COMP%], .faq-link[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{font-style:italic;color:#106fad;font-size:small}fly-icon[_ngcontent-%COMP%]{color:#106fad;width:.95rem;height:.95rem}.missing-flight[_ngcontent-%COMP%]{display:inline-flex;padding-bottom:.5rem}.no-logs-container[_ngcontent-%COMP%]{display:flex;flex-direction:column}.loader[_ngcontent-%COMP%]{margin:auto}.date-picker-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;gap:.25rem}.black[_ngcontent-%COMP%]{background-color:#000;height:1px;margin-bottom:1.5rem;width:100%;border:0 solid #000}.missing-flight2[_ngcontent-%COMP%]{display:flex}.question-icon[_ngcontent-%COMP%]{padding-right:.2rem;padding-top:.15rem}.upload-share-btns[_ngcontent-%COMP%]{display:flex;gap:1rem;flex-wrap:wrap}@media screen and (min-width: 768px){.upload-share-btns[_ngcontent-%COMP%]{margin-left:9rem;margin-top:2.3rem}}"]
    });
  }
  return AircraftLogbookEntriesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FileUploaderService = /*#__PURE__*/(() => {
  class FileUploaderService {
    selectedFiles = signal([]);
    allowedFileTypes = signal(undefined);
    setAllowedFileTypes(allowedTypes) {
      this.allowedFileTypes.set(allowedTypes);
    }
    addFilesToSelection(files) {
      const filteredFiles = Array.from(files).filter(file => this.allowedFileTypes()?.some(type => file.name.endsWith(type)) ?? true);
      if (filteredFiles.length > 0) {
        filteredFiles.forEach(file => {
          const existingFileIndex = this.selectedFiles().findIndex(f => f.name === file.name);
          const currentSelectedFiles = this.selectedFiles();
          if (existingFileIndex >= 0) {
            // Replace the file if it already exists
            currentSelectedFiles[existingFileIndex] = file;
          } else {
            // Add the file if it doesn't exist
            currentSelectedFiles.push(file);
          }
          this.selectedFiles.set(currentSelectedFiles);
        });
      } else {
        alert(`Please select only the following file types: ${this.allowedFileTypes}.`);
      }
    }
    deleteFile(index) {
      const currentlySelectedFiles = this.selectedFiles();
      currentlySelectedFiles.splice(index, 1);
      this.selectedFiles.set(currentlySelectedFiles);
    }
    clearSelectedFiles() {
      this.selectedFiles.set([]);
    }
    static ɵfac = function FileUploaderService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FileUploaderService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FileUploaderService,
      factory: FileUploaderService.ɵfac
    });
  }
  return FileUploaderService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SelectFilesComponent = /*#__PURE__*/(() => {
  class SelectFilesComponent {
    allowedFileTypes = input();
    fileUploaderService = inject(FileUploaderService);
    onFileSelected(event) {
      const files = event.target.files;
      if (files.length > 0) {
        this.fileUploaderService.addFilesToSelection(files);
      }
      event.target.value = null;
    }
    onDragOver(event) {
      event.preventDefault();
    }
    onDrop(event) {
      event.preventDefault();
      const files = event.dataTransfer?.files;
      if (files != null && files.length > 0) {
        this.fileUploaderService.addFilesToSelection(files);
      }
    }
    static ɵfac = function SelectFilesComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SelectFilesComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SelectFilesComponent,
      selectors: [["aclogbook-select-files"]],
      inputs: {
        allowedFileTypes: [1, "allowedFileTypes"]
      },
      decls: 13,
      vars: 1,
      consts: [["fileInput", ""], ["for", "fileUpload"], [1, "file-upload"], [1, "drop-area", 3, "dragover", "drop"], [1, "text"], [1, "browse-btn"], ["size", "medium", 3, "click"], ["type", "file", "id", "fileUpload", "multiple", "", "accept", ".zip", 1, "file-input", 3, "change"], [1, "select-files"], [1, "file-list"], [1, "file-item"], [1, "file-name"], [1, "delete-btn", 3, "click"], ["icon", "x", 1, "icon", "size-small"]],
      template: function SelectFilesComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelement(0, "label", 1);
          i0.ɵɵelementStart(1, "div", 2)(2, "div", 3);
          i0.ɵɵlistener("dragover", function SelectFilesComponent_Template_div_dragover_2_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onDragOver($event));
          })("drop", function SelectFilesComponent_Template_div_drop_2_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onDrop($event));
          });
          i0.ɵɵelementStart(3, "p", 4);
          i0.ɵɵtext(4, "Drag and drop files");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "p", 4);
          i0.ɵɵtext(6, "OR");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(7, "div", 5)(8, "g-button", 6);
          i0.ɵɵlistener("click", function SelectFilesComponent_Template_g_button_click_8_listener() {
            i0.ɵɵrestoreView(_r1);
            const fileInput_r2 = i0.ɵɵreference(11);
            return i0.ɵɵresetView(fileInput_r2.click());
          });
          i0.ɵɵtext(9, "BROWSE FOR FILES");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(10, "input", 7, 0);
          i0.ɵɵlistener("change", function SelectFilesComponent_Template_input_change_10_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onFileSelected($event));
          });
          i0.ɵɵelementEnd()()()();
          i0.ɵɵtemplate(12, SelectFilesComponent_Conditional_12_Template, 6, 0, "div", 8);
        }
        if (rf & 2) {
          i0.ɵɵadvance(12);
          i0.ɵɵconditional(ctx.fileUploaderService.selectedFiles().length > 0 ? 12 : -1);
        }
      },
      dependencies: [CommonModule, ComponentsGlobalWebModule, i2.GButton, IconComponent],
      styles: [".file-upload[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;background-color:#eee;width:100%;height:15rem;margin-top:2rem}.drop-area[_ngcontent-%COMP%]{align-items:center;display:flex;flex-direction:column;font-weight:700;background-color:#fff;outline:2px dashed #000;width:98%;height:92%;padding:1rem;text-align:center}.drop-area[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{margin-top:2rem}.browse-btm[_ngcontent-%COMP%]{margin-bottom:2rem}.file-input[_ngcontent-%COMP%]{display:none}.select-files[_ngcontent-%COMP%]{background-color:#eee;width:100%;height:fit-content;margin-top:0}.file-list[_ngcontent-%COMP%]{padding:.5rem}.file-item[_ngcontent-%COMP%]{display:flex;justify-content:space-between;border:2px solid rgb(178.5,178.5,178.5);background-color:#fff;padding:1rem;margin-top:.5rem;font-weight:700}.delete-btn[_ngcontent-%COMP%]{font-weight:700;width:1rem;height:1rem;margin-top:4px}.select-files[_ngcontent-%COMP%]   .file-upload[_ngcontent-%COMP%]{margin-bottom:0}"]
    });
  }
  return SelectFilesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FileUploaderComponent = /*#__PURE__*/(() => {
  class FileUploaderComponent {
    filesUploaded = new EventEmitter();
    fileUploaderService = inject(FileUploaderService);
    uploadLogs() {
      this.filesUploaded.emit(this.fileUploaderService.selectedFiles());
    }
    static ɵfac = function FileUploaderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FileUploaderComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FileUploaderComponent,
      selectors: [["aclogbook-file-uploader"]],
      outputs: {
        filesUploaded: "filesUploaded"
      },
      decls: 6,
      vars: 2,
      consts: [[1, "upload-files"], [1, "upload-logs-btn"], ["theme", "black", "size", "medium", 3, "click", "disabled"], [1, "upload-btn-txt"]],
      template: function FileUploaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵelement(1, "aclogbook-select-files");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(2, "div", 1)(3, "g-button", 2);
          i0.ɵɵlistener("click", function FileUploaderComponent_Template_g_button_click_3_listener() {
            return ctx.uploadLogs();
          });
          i0.ɵɵtext(4, " UPLOAD LOGS ");
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(5, FileUploaderComponent_Conditional_5_Template, 2, 0, "p", 3);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("disabled", ctx.fileUploaderService.selectedFiles().length === 0);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.fileUploaderService.selectedFiles().length === 0 ? 5 : -1);
        }
      },
      dependencies: [CommonModule, ComponentsGlobalWebModule, i2.GButton, RouterModule, SelectFilesComponent],
      styles: [".upload-logs-btn[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;flex-direction:column;align-items:flex-end;gap:.5rem;margin:1rem 0}.upload-btn-txt[_ngcontent-%COMP%]{font-weight:700}"]
    });
  }
  return FileUploaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AircraftLogbookUploadFlyGarminComponent = /*#__PURE__*/(() => {
  class AircraftLogbookUploadFlyGarminComponent {
    config = inject(FLY_WEB_COMMON_CONFIG);
    aircraftFlightLogUploadService = inject(AircraftFlightLogUploadService);
    fileUploaderService = inject(FileUploaderService);
    pilotLogbookUrl = `${FlyGarminLegacyBaseUrl[this.config.environment]}/logbook/#/list`;
    uploaded = false;
    failedUpload = false;
    ngOnInit() {
      this.fileUploaderService.setAllowedFileTypes(['.zip']);
    }
    uploadFiles(filesSelected) {
      forkJoin(filesSelected.map(file => this.aircraftFlightLogUploadService.uploadAircraftData(file))).subscribe({
        error: () => {
          // If any observable fails
          this.failedUpload = true;
        },
        complete: () => {
          this.uploaded = true;
        }
      });
    }
    static ɵfac = function AircraftLogbookUploadFlyGarminComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AircraftLogbookUploadFlyGarminComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AircraftLogbookUploadFlyGarminComponent,
      selectors: [["aclogbook-aircraft-logbook-upload-fly-garmin"]],
      features: [i0.ɵɵProvidersFeature([FileUploaderService])],
      decls: 2,
      vars: 1,
      consts: [[1, "success-container"], [3, "href"], [3, "filesUploaded"], [1, "error-txt"], [1, "upload-failed-txt"], [3, "routerLink"], ["icon", "checkmark-circle-sharp", 1, "icon", "green"], [1, "page-txt"], [1, "last-txt"], [1, "btn"], ["size", "medium"]],
      template: function AircraftLogbookUploadFlyGarminComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, AircraftLogbookUploadFlyGarminComponent_Conditional_0_Template, 12, 2)(1, AircraftLogbookUploadFlyGarminComponent_Conditional_1_Template, 23, 6, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵconditional(!ctx.uploaded ? 0 : 1);
        }
      },
      dependencies: [CommonModule, ComponentsGlobalWebModule, i2.GButton, RouterModule, i2$1.RouterLink, FileUploaderComponent, IconComponent],
      styles: ["[_nghost-%COMP%]{margin:0;padding:1rem;display:block}@media screen and (min-width: 768px){[_nghost-%COMP%]{max-width:1200px;margin:0 auto}}.error-txt[_ngcontent-%COMP%]{display:flex;justify-content:flex-end}.upload-failed-txt[_ngcontent-%COMP%]{font-weight:700;color:#920000;width:30%;margin-bottom:1.5rem;padding-left:2rem}.upload-failed-txt[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#920000}@media (max-width: 768px){.upload-failed-txt[_ngcontent-%COMP%]{width:100%}}.success-container[_ngcontent-%COMP%]{display:flex;align-items:center;flex-direction:column;margin-top:3rem}.page-txt[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center;margin-top:1rem}.page-txt[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]:not(:last-child){margin-top:4px}.last-txt[_ngcontent-%COMP%]{margin-top:1.5rem}.btn[_ngcontent-%COMP%]{margin-top:2.5rem}.icon.green[_ngcontent-%COMP%]{color:#4bb450}"]
    });
  }
  return AircraftLogbookUploadFlyGarminComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const STORAGE_KEYS = {
  UPLOADED_LOGS_KEY: 'uploadedLogs'
};
let AircraftLogbookUploadFlyAdminComponent = /*#__PURE__*/(() => {
  class AircraftLogbookUploadFlyAdminComponent {
    localStorageService = inject(LocalStorageService);
    aircraftFlightLogUploadService = inject(AircraftFlightLogUploadService);
    fileUploaderService = inject(FileUploaderService);
    destroyRef = inject(DestroyRef);
    uploadedLogs = [];
    processingSubscriptions$ = [];
    ngOnInit() {
      this.fileUploaderService.setAllowedFileTypes(['.zip']);
      this.uploadedLogs = this.getLogsFromLocalStorage();
      this.uploadedLogs.filter(uploadedLog => uploadedLog.status.toLowerCase() === 'processing').forEach(uploadedLog => this.handleProcessingUpload(uploadedLog).subscribe());
    }
    uploadFiles(filesSelected) {
      filesSelected.forEach(file => {
        this.aircraftFlightLogUploadService.uploadAircraftData(file).pipe(map(response => {
          // On success
          return this.addFileToLocalStorage(file, 'PROCESSING', response.uuid);
        }), switchMap(response => {
          this.fileUploaderService.clearSelectedFiles();
          return this.handleProcessingUpload(response);
        }), catchError(() => {
          // On failure
          this.updateFileStatus(file.name, 'FAILED');
          return [];
        })).subscribe();
      });
    }
    // Adding new file and updating the storage
    addFileToLocalStorage(file, status, uploadUuid) {
      const fileData = {
        fileName: file.name,
        uploadUuid: uploadUuid,
        status: status
      };
      this.setLogsToLocalStorage([...this.getLogsFromLocalStorage(), fileData]);
      this.uploadedLogs = this.getLogsFromLocalStorage();
      return fileData;
    }
    // Update status of a specific file
    updateFileStatus(fileName, status, uploadUuid) {
      const currentLogs = this.uploadedLogs;
      const fileIndex = currentLogs.findIndex(log => log.fileName === fileName && log.uploadUuid == uploadUuid);
      let updatedLog = null;
      if (fileIndex !== -1) {
        currentLogs[fileIndex].status = status;
        if (uploadUuid != null) {
          currentLogs[fileIndex].uploadUuid = uploadUuid;
          updatedLog = currentLogs[fileIndex];
        }
        this.setLogsToLocalStorage(currentLogs);
      }
      this.uploadedLogs = currentLogs;
      return updatedLog;
    }
    getLogsFromLocalStorage() {
      return this.localStorageService.get(STORAGE_KEYS.UPLOADED_LOGS_KEY) ?? [];
    }
    setLogsToLocalStorage(logs) {
      this.localStorageService.set(STORAGE_KEYS.UPLOADED_LOGS_KEY, logs);
    }
    handleProcessingUpload(uploadedLog) {
      return interval(5000).pipe(startWith(0), switchMap(() => this.aircraftFlightLogUploadService.getUploadStatus(uploadedLog.uploadUuid)), catchError(() => of({
        status: 'PROCESSING'
      })), this.distinctUntilChangedJSONCheck, filter(response => response != null), tap(jobResponse => {
        if (jobResponse.status.toLowerCase() === 'success') {
          this.updateFileStatus(uploadedLog.fileName, 'COMPLETED', uploadedLog.uploadUuid);
        } else if (jobResponse.status.toLowerCase() === 'failed') {
          this.updateFileStatus(uploadedLog.fileName, 'ERROR', uploadedLog.uploadUuid);
        }
      }), takeWhile(statusResponse => statusResponse?.status.toLowerCase() === 'processing'), takeUntilDestroyed(this.destroyRef));
    }
    distinctUntilChangedJSONCheck = distinctUntilChanged((previous, current) => JSON.stringify(previous) === JSON.stringify(current));
    downloadLog(uploadedLog) {
      this.aircraftFlightLogUploadService.getLogFile(uploadedLog.uploadUuid).subscribe(blob => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `aircraft-log-${new Date().toISOString()}-${uploadedLog.uploadUuid}.csv.gz`;
        a.click();
        URL.revokeObjectURL(url);
      });
    }
    static ɵfac = function AircraftLogbookUploadFlyAdminComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AircraftLogbookUploadFlyAdminComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AircraftLogbookUploadFlyAdminComponent,
      selectors: [["aclogbook-aircraft-logbook-upload-flyadmin"]],
      features: [i0.ɵɵProvidersFeature([FileUploaderService])],
      decls: 15,
      vars: 1,
      consts: [[3, "filesUploaded"], [1, "desktop"], [1, "status"], [1, "mobile"], [1, "status", "error"], ["title", "Download", "aria-label", "Download Log", 1, "download-link", 3, "click"], ["icon", "download", 1, "icon", "size-standard"]],
      template: function AircraftLogbookUploadFlyAdminComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "h1");
          i0.ɵɵtext(1, "Upload and Decrypt Aircraft Flight Logs");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(2, "p");
          i0.ɵɵtext(3, "Uploads on this page will be automatically sent to the customer's aircraft logbook and decrypted for download.");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(4, "p");
          i0.ɵɵtext(5, "You can view the status of the initial processing below and can download decrypted files that you have uploaded.");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(6, "p")(7, "strong");
          i0.ɵɵtext(8, "Note:");
          i0.ɵɵelementEnd();
          i0.ɵɵtext(9, " You can only download the the below files from your specific browser instance, and clearing your cookies will remove the items from the list. If you need a file that is not available below or on another browser, you can re-upload the file and it will be available for download.\n");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(10, "aclogbook-file-uploader", 0);
          i0.ɵɵlistener("filesUploaded", function AircraftLogbookUploadFlyAdminComponent_Template_aclogbook_file_uploader_filesUploaded_10_listener($event) {
            return ctx.uploadFiles($event);
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(11, "h2");
          i0.ɵɵtext(12, "Download Decrypted Logs");
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(13, AircraftLogbookUploadFlyAdminComponent_Conditional_13_Template, 22, 0)(14, AircraftLogbookUploadFlyAdminComponent_Conditional_14_Template, 2, 0, "span");
        }
        if (rf & 2) {
          i0.ɵɵadvance(13);
          i0.ɵɵconditional(ctx.uploadedLogs.length > 0 ? 13 : 14);
        }
      },
      dependencies: [FileUploaderComponent, IconComponent],
      styles: ["td[_ngcontent-%COMP%]{vertical-align:middle;text-align:left}th[_ngcontent-%COMP%]{text-align:left;text-transform:uppercase}thead[_ngcontent-%COMP%]{border-bottom:solid 1px black}.icon.size-small[_ngcontent-%COMP%]{width:.875rem;height:.875rem}.icon.size-standard[_ngcontent-%COMP%]{width:1.125rem;height:1.125rem}.icon.size-large[_ngcontent-%COMP%]{width:1.75rem;height:1.75rem}.icon.color-black[_ngcontent-%COMP%]{color:#000}.icon.color-red[_ngcontent-%COMP%]{color:#920000}.icon.color-green[_ngcontent-%COMP%]{color:#4bb450}.icon.color-yellow[_ngcontent-%COMP%]{color:#ffaf33}.icon.color-garmin-blue[_ngcontent-%COMP%]{color:#106fad}.icon.color-dark-gray[_ngcontent-%COMP%]{color:#737373}.icon.effect-hover[_ngcontent-%COMP%]{opacity:0;transition:opacity .2s}.icon.effect-hover[_ngcontent-%COMP%]:hover, .icon.effect-hover[_ngcontent-%COMP%]:focus-visible{opacity:1}.icon.prop-clickable[_ngcontent-%COMP%]{cursor:pointer}thead[_ngcontent-%COMP%]{border-bottom:solid 2px black}[_nghost-%COMP%]{display:flex;flex-direction:column;margin:1rem;gap:1rem}h2[_ngcontent-%COMP%]{margin:0}.status[_ngcontent-%COMP%]{text-align:end}.download-link[_ngcontent-%COMP%]{display:flex;justify-content:flex-end}.download[_ngcontent-%COMP%]:hover{cursor:pointer}.error[_ngcontent-%COMP%]{color:#920000}td[_ngcontent-%COMP%]{word-wrap:break-word}.mobile[_ngcontent-%COMP%]{display:table}@media screen and (min-width: 1024px){.mobile[_ngcontent-%COMP%]{display:none}}.desktop[_ngcontent-%COMP%]{display:none}@media screen and (min-width: 1024px){.desktop[_ngcontent-%COMP%]{display:table}}"]
    });
  }
  return AircraftLogbookUploadFlyAdminComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const AIRCRAFT_LOGBOOK_CONFIG = new InjectionToken('AIRCRAFT_LOGBOOK_CONFIG');
let SupportsAircraftLogbookPipe = /*#__PURE__*/(() => {
  class SupportsAircraftLogbookPipe {
    config = inject(AIRCRAFT_LOGBOOK_CONFIG);
    transform(aircraft) {
      return aircraft.systems?.some(system => system.devices?.some(device => this.config.eligibleConnectedDevice.includes(device.deviceId))) === true;
    }
    static ɵfac = function SupportsAircraftLogbookPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SupportsAircraftLogbookPipe)();
    };
    static ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "aclogbookSupportsAircraftLogbook",
      type: SupportsAircraftLogbookPipe,
      pure: true
    });
  }
  return SupportsAircraftLogbookPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AircraftFlightLogCacheService = /*#__PURE__*/(() => {
  class AircraftFlightLogCacheService {
    cache = new Map();
    aircraftFlightLogService = inject(AircraftFlightLogService);
    getFlightLogsForSingleAircraft(aircraft) {
      const aircraftUuid = aircraft.aircraftUuid;
      if (aircraftUuid == null || aircraft.masterAircraftUuid == null) {
        return of(null);
      } else if (this.cache.has(aircraftUuid)) {
        return of(this.cache.get(aircraftUuid) ?? null);
      } else {
        return this.aircraftFlightLogService.getFlightLogsByAircraft({
          masterAircraftId: aircraft.masterAircraftUuid
        }).pipe(tap(logbookData => this.cache.set(aircraftUuid, logbookData)), catchError(() => of(null)));
      }
    }
    getFlightLogsForMultipleAircraft(aircraftList) {
      return forkJoin(aircraftList.map(aircraft => this.getFlightLogsForSingleAircraft(aircraft))).pipe(map(() => this.cache));
    }
    static ɵfac = function AircraftFlightLogCacheService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AircraftFlightLogCacheService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AircraftFlightLogCacheService,
      factory: AircraftFlightLogCacheService.ɵfac
    });
  }
  return AircraftFlightLogCacheService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LogbookAircraftPagingService = /*#__PURE__*/(() => {
  class LogbookAircraftPagingService {
    static DEFAULT_AIRCRAFT_PER_PAGE = 10;
    aircraftReadService = inject(AircraftReadService);
    aircraftFlightLogCacheService = inject(AircraftFlightLogCacheService);
    supportsAircraftLogbookPipe = inject(SupportsAircraftLogbookPipe);
    destroyRef = inject(DestroyRef);
    _aircraft = signal(null);
    //Private signals that are writable internally, but should only be readable externally
    _aircraftFilter = signal(null);
    _aircraftPerPage = signal(LogbookAircraftPagingService.DEFAULT_AIRCRAFT_PER_PAGE);
    _currentPageNumber = signal(0);
    _hasError = signal(false);
    _isLoading = signal(false);
    _filteredAircraft = computed(() => {
      const aircraft = this._aircraft();
      const filters = this._aircraftFilter()?.toUpperCase().split(' ');
      if (aircraft == null) {
        return null;
      }
      if (filters == null || filters.length == 0 || filters.every(filter => filter == '')) {
        return aircraft;
      }
      return aircraft.filter(ac => {
        const make = ac.model?.make?.name?.toUpperCase() ?? '';
        const model = ac.model?.name?.toUpperCase() ?? '';
        const tail = ac.tailNumber?.toUpperCase() ?? '';
        const sanitizedTail = ac.sanitizedTailNumber?.toUpperCase() ?? '';
        const name = ac.name?.toUpperCase() ?? '';
        return filters.every(filter => make.includes(filter) || model.includes(filter) || model.includes(filter) || tail.includes(filter) || sanitizedTail.includes(filter) || name.includes(filter));
      });
    });
    currentPage = computed(() => {
      const aircraft = this._filteredAircraft();
      if (aircraft == null) {
        return null;
      }
      const pageNumber = this._currentPageNumber();
      const pageSize = this._aircraftPerPage();
      return aircraft.slice(pageNumber * pageSize, (pageNumber + 1) * pageSize);
    });
    numberOfPages = computed(() => {
      const aircraft = this._filteredAircraft() ?? [];
      const aircraftPerPage = this._aircraftPerPage();
      return Math.ceil(aircraft.length / aircraftPerPage);
    });
    totalNumberOfAircraft = computed(() => {
      return this._aircraft()?.length ?? 0;
    });
    totalFilteredAircraft = computed(() => {
      return this._filteredAircraft()?.length ?? 0;
    });
    //Computed readonly signals that just return the private writable signal.
    aircraftFilter = this._aircraftFilter.asReadonly();
    aircraftPerPage = this._aircraftPerPage.asReadonly();
    currentPageNumber = this._currentPageNumber.asReadonly();
    hasError = this._hasError.asReadonly();
    isLoading = this._isLoading.asReadonly();
    reset() {
      if (this._isLoading()) {
        throw new Error();
      } else {
        this._isLoading.set(true);
        this._aircraft.set(null);
        this._hasError.set(false);
      }
      this.aircraftReadService.getAircraft(undefined, true, false).pipe(switchMap(aircraftList => forkJoin([of(aircraftList), this.aircraftFlightLogCacheService.getFlightLogsForMultipleAircraft(aircraftList)])), takeUntilDestroyed(this.destroyRef)).subscribe({
        next: data => {
          const [aircraftList, aircraftLogbookMap] = data;
          const {
            logbookEligibleAircraftWithLogs,
            aircraftWithoutLogs
          } = aircraftList.reduce((filteredLists, aircraft) => {
            const hasLogs = (aircraftLogbookMap.get(aircraft.aircraftUuid ?? '')?.page.totalElements ?? 0) > 0;
            filteredLists[hasLogs ? 'logbookEligibleAircraftWithLogs' : 'aircraftWithoutLogs'].push(aircraft);
            return filteredLists;
          }, {
            logbookEligibleAircraftWithLogs: [],
            aircraftWithoutLogs: []
          });
          const {
            logbookEligibleAircraftWithoutLogs,
            logbookIneligibleAircraft
          } = aircraftWithoutLogs.reduce((filteredArrays, aircraft) => {
            const eligibleForLogs = this.supportsAircraftLogbookPipe.transform(aircraft);
            filteredArrays[eligibleForLogs ? 'logbookEligibleAircraftWithoutLogs' : 'logbookIneligibleAircraft'].push(aircraft);
            return filteredArrays;
          }, {
            logbookEligibleAircraftWithoutLogs: [],
            logbookIneligibleAircraft: []
          });
          const logbookEligibleAircraftWithLogsSortedByMostRecentLog = logbookEligibleAircraftWithLogs.sort((a, b) => {
            const aMostRecentLogDateString = aircraftLogbookMap.get(a.aircraftUuid ?? '')?.lastModifiedDate;
            const bMostRecentLogDateString = aircraftLogbookMap.get(b.aircraftUuid ?? '')?.lastModifiedDate;
            const aLastModifiedDate = aMostRecentLogDateString != null ? parseISO(aMostRecentLogDateString) : new Date(0);
            const bLastModifiedDate = bMostRecentLogDateString != null ? parseISO(bMostRecentLogDateString) : new Date(0);
            return compareDesc(aLastModifiedDate, bLastModifiedDate);
          });
          const sortedAircraft = [...logbookEligibleAircraftWithLogsSortedByMostRecentLog, ...logbookEligibleAircraftWithoutLogs, ...logbookIneligibleAircraft];
          this._aircraft.set(sortedAircraft);
          this._isLoading.set(false);
          this._hasError.set(false);
        },
        error: e => {
          console.error(e);
          this._isLoading.set(false);
          this._hasError.set(true);
        }
      });
    }
    setAircraftFilter(filter) {
      this._currentPageNumber.set(0);
      this._aircraftFilter.set(filter);
    }
    setAircraftPerPage(aircraftPerPage) {
      this._currentPageNumber.set(0);
      this._aircraftPerPage.set(aircraftPerPage);
    }
    setPage(pageNumber) {
      if (pageNumber < 0 || pageNumber != 0 && pageNumber > this.numberOfPages() - 1) {
        throw new Error(`Unable to set page to ${pageNumber}. Out of bounds.`);
      }
      this._currentPageNumber.set(pageNumber);
    }
    previousPage() {
      if (this._currentPageNumber() === 0) {
        throw new Error(`Unable to go to previous page if current page is 0. Current value: ${this._currentPageNumber()}`);
      }
      this._currentPageNumber.update(prevPageNumber => prevPageNumber - 1);
    }
    nextPage() {
      if (this._currentPageNumber() === this.numberOfPages() - 1) {
        throw new Error(`Unable to increment page. This is the last page. Current value: ${this._currentPageNumber()}`);
      }
      this._currentPageNumber.update(prevPageNumber => prevPageNumber + 1);
    }
    static ɵfac = function LogbookAircraftPagingService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LogbookAircraftPagingService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: LogbookAircraftPagingService,
      factory: LogbookAircraftPagingService.ɵfac
    });
  }
  return LogbookAircraftPagingService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LogbookAircraftCardComponent = /*#__PURE__*/(() => {
  class LogbookAircraftCardComponent {
    aircraft;
    aircraftFlightLogCacheService = inject(AircraftFlightLogCacheService);
    FALLBACK_IMAGE_URL = `${GARMIN_CDN_URL}/apps/fly/img/aircraft-placeholders/default.png`;
    http = inject(HttpClient);
    numberOfElements;
    imageUrl = signal(null);
    imageObjectUrl = null;
    faqUrl = PAGE_URLS.FAQ_URL;
    learnMoreUrl = PAGE_URLS.LEARN_MORE_URL;
    ngOnInit() {
      const aircraftImageUrl = this.aircraft?.imageUrl;
      if (aircraftImageUrl == null) {
        throw new Error('Aircraft image URL is unexpectedly null');
      }
      if (aircraftImageUrl.includes(GARMIN_CDN_URL)) {
        this.imageUrl.set(aircraftImageUrl);
      } else {
        this.http.get(aircraftImageUrl, {
          responseType: 'blob'
        }).subscribe({
          next: data => {
            this.imageObjectUrl = URL.createObjectURL(data);
            this.imageUrl.set(this.imageObjectUrl);
          },
          error: () => {
            this.imageUrl.set(this.FALLBACK_IMAGE_URL);
          }
        });
      }
      if (this.aircraft != null && this.aircraft.masterAircraftUuid != null) {
        this.aircraftFlightLogCacheService.getFlightLogsForSingleAircraft(this.aircraft).subscribe(response => {
          this.numberOfElements = response?.page.totalElements ?? 0;
        });
      } else if (this.aircraft != null && this.aircraft.masterAircraftUuid == null) {
        this.numberOfElements = 0;
      }
    }
    ngOnDestroy() {
      if (this.imageObjectUrl != null) {
        URL.revokeObjectURL(this.imageObjectUrl);
      }
    }
    static ɵfac = function LogbookAircraftCardComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LogbookAircraftCardComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: LogbookAircraftCardComponent,
      selectors: [["aclogbook-logbook-aircraft-card"]],
      inputs: {
        aircraft: "aircraft"
      },
      decls: 12,
      vars: 5,
      consts: [[1, "container"], [1, "card-image"], [1, "image", 3, "src"], [1, "card-content"], [1, "name"], [1, "makeModel"], [1, "totalAndButton", 3, "ngPlural"], ["ngPluralCase", "=0"], ["ngPluralCase", "=1"], ["ngPluralCase", "other"], [1, "tailNumber"], ["target", "_blank", 3, "href"], ["size", "small"], [3, "routerLink"], ["theme", "black", "size", "small"]],
      template: function LogbookAircraftCardComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
          i0.ɵɵelement(2, "img", 2);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "div", 3);
          i0.ɵɵtemplate(4, LogbookAircraftCardComponent_Conditional_4_Template, 2, 1, "span", 4)(5, LogbookAircraftCardComponent_Conditional_5_Template, 4, 2);
          i0.ɵɵelementStart(6, "p", 5);
          i0.ɵɵtext(7);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(8, "div", 6);
          i0.ɵɵtemplate(9, LogbookAircraftCardComponent_ng_template_9_Template, 3, 3, "ng-template", 7)(10, LogbookAircraftCardComponent_ng_template_10_Template, 5, 3, "ng-template", 8)(11, LogbookAircraftCardComponent_ng_template_11_Template, 5, 4, "ng-template", 9);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          let tmp_3_0;
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("src", ctx.imageUrl(), i0.ɵɵsanitizeUrl);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.aircraft.name == null ? 4 : 5);
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate2("", ctx.aircraft.model == null ? null : ctx.aircraft.model.make == null ? null : ctx.aircraft.model.make.name, " ", ctx.aircraft.model == null ? null : ctx.aircraft.model.name, "");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngPlural", (tmp_3_0 = ctx.numberOfElements) !== null && tmp_3_0 !== undefined ? tmp_3_0 : 0);
        }
      },
      dependencies: [CommonModule, i1.NgPlural, i1.NgPluralCase, ComponentsGlobalWebModule, i2.GButton, RouterModule, i2$1.RouterLink, SupportsAircraftLogbookPipe],
      styles: [".container[_ngcontent-%COMP%]{display:flex;box-shadow:0 1px 1px #4d4d4d14,0 1px 3px 1px #4d4d4d29;background-color:#fafafa;flex-direction:column}@media screen and (min-width: 480px){.container[_ngcontent-%COMP%]{flex-direction:row}}.card-image[_ngcontent-%COMP%]{flex:0 0 auto}@media screen and (min-width: 768px){.card-image[_ngcontent-%COMP%]{flex-direction:row;height:9rem;width:10rem;margin:1rem 1rem .75rem;overflow:hidden;display:flex;justify-content:center;align-items:center}}.image[_ngcontent-%COMP%]{display:none;max-width:100%;max-height:100%;width:auto;height:auto}@media screen and (min-width: 480px){.image[_ngcontent-%COMP%]{flex-direction:row;display:block}}.card-content[_ngcontent-%COMP%]{display:flex;flex-direction:column;height:100%;margin-right:1rem;justify-content:left;height:max-content;padding-left:1rem;padding-bottom:1rem;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}@media screen and (min-width: 768px){.card-content[_ngcontent-%COMP%]{padding-left:0;padding-bottom:0;justify-content:left}}.makeModel[_ngcontent-%COMP%]{color:gray}.card-content[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-size:.875rem}.totalAndButton[_ngcontent-%COMP%]{margin-top:.2rem;display:flex;flex-direction:column;gap:.5rem;margin-bottom:1rem}.name[_ngcontent-%COMP%]{text-overflow:ellipsis;white-space:nowrap;overflow:hidden;font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1rem;margin:1rem 0;font-size:1.5rem}@media screen and (min-width: 768px){.name[_ngcontent-%COMP%]{font-size:1.25rem}}@media screen and (min-width: 768px){.name[_ngcontent-%COMP%]{margin-top:1rem}}"]
    });
  }
  return LogbookAircraftCardComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LogbookAircraftListItemComponent = /*#__PURE__*/(() => {
  class LogbookAircraftListItemComponent {
    aircraft;
    aircraftFlightLogCacheService = inject(AircraftFlightLogCacheService);
    numberOfElements = 0;
    faqUrl = PAGE_URLS.FAQ_URL;
    learnMoreUrl = PAGE_URLS.LEARN_MORE_URL;
    ngOnInit() {
      if (this.aircraft.masterAircraftUuid != null) {
        this.aircraftFlightLogCacheService.getFlightLogsForSingleAircraft(this.aircraft).subscribe(response => {
          this.numberOfElements = response?.page.totalElements ?? 0;
        });
      } else if (this.aircraft != null && this.aircraft.masterAircraftUuid == null) {
        this.numberOfElements = 0;
      }
    }
    static ɵfac = function LogbookAircraftListItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LogbookAircraftListItemComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: LogbookAircraftListItemComponent,
      selectors: [["aclogbook-logbook-aircraft-list-item"]],
      inputs: {
        aircraft: "aircraft"
      },
      decls: 11,
      vars: 6,
      consts: [[1, "list-container"], [1, "nameMakeModel"], [1, "makeModel"], [1, "name"], [1, "totalAndButton"], [3, "routerLink"], ["theme", "black", "size", "small"], ["target", "_blank", 3, "href"], ["size", "small"]],
      template: function LogbookAircraftListItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "p", 2);
          i0.ɵɵtext(3);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(4, LogbookAircraftListItemComponent_Conditional_4_Template, 2, 1, "span", 3)(5, LogbookAircraftListItemComponent_Conditional_5_Template, 2, 2, "span", 3);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(6, "div", 4);
          i0.ɵɵtemplate(7, LogbookAircraftListItemComponent_Conditional_7_Template, 5, 4);
          i0.ɵɵpipe(8, "aclogbookSupportsAircraftLogbook");
          i0.ɵɵtemplate(9, LogbookAircraftListItemComponent_Conditional_9_Template, 5, 2)(10, LogbookAircraftListItemComponent_Conditional_10_Template, 5, 1);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate2("", ctx.aircraft.model == null ? null : ctx.aircraft.model.make == null ? null : ctx.aircraft.model.make.name, " ", ctx.aircraft.model == null ? null : ctx.aircraft.model.name, "");
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.aircraft.name == null ? 4 : 5);
          i0.ɵɵadvance(3);
          i0.ɵɵconditional(ctx.numberOfElements !== 0 ? 7 : ctx.numberOfElements === 0 && i0.ɵɵpipeBind1(8, 4, ctx.aircraft) ? 9 : 10);
        }
      },
      dependencies: [ComponentsGlobalWebModule, i2.GButton, RouterModule, i2$1.RouterLink, SupportsAircraftLogbookPipe],
      styles: [".list-container[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:space-between;border-bottom:2px solid #eee}.name[_ngcontent-%COMP%]{text-overflow:ellipsis;white-space:nowrap;overflow:hidden;font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1rem;margin:1rem 0;font-size:1.5rem}@media screen and (min-width: 768px){.name[_ngcontent-%COMP%]{font-size:1.25rem}}.makeModel[_ngcontent-%COMP%]{color:gray;font-size:.875rem;margin-bottom:.5rem;margin-top:-.3rem}.nameMakeModel[_ngcontent-%COMP%]{flex-direction:column;margin-bottom:1.5rem}.totalAndButton[_ngcontent-%COMP%]{flex-direction:column;float:right;text-align:right}.totalAndButton[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:gray;font-size:.875rem;margin-bottom:.5rem}"]
    });
  }
  return LogbookAircraftListItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LogbookAircraftComponent = /*#__PURE__*/(() => {
  class LogbookAircraftComponent {
    localStorageService = inject(LocalStorageService);
    logbookPagingService = inject(LogbookAircraftPagingService);
    defaultAircraftPerPage = LogbookAircraftPagingService.DEFAULT_AIRCRAFT_PER_PAGE;
    searchControl = new FormControl(null);
    featuresService = inject(FeaturesService);
    aircraftPerPageControl = new FormControl(this.logbookPagingService.aircraftPerPage());
    aircraftOnCurrentPage = computed(() => {
      return this.logbookPagingService.currentPage()?.length ?? 0;
    });
    firstAircraftNumberOnCurrentPage = computed(() => {
      return this.logbookPagingService.currentPageNumber() * this.logbookPagingService.aircraftPerPage() + 1;
    });
    lastAircraftNumberOnCurrentPage = computed(() => {
      return this.firstAircraftNumberOnCurrentPage() + this.aircraftOnCurrentPage() - 1;
    });
    destroyRef = inject(DestroyRef);
    viewMode = 'LIST';
    aircraftLogbookViewMode = '';
    uploadLogsEnabled = false;
    ngOnInit() {
      const customerGuid = this.localStorageService.get(LocalStorageKey.OAuthTokenResponse)?.customerId;
      if (customerGuid == null) throw Error('invalid customer id');
      this.aircraftLogbookViewMode = `${customerGuid}/aircraft-logbook-view-mode`;
      const savedViewMode = this.localStorageService.get(this.aircraftLogbookViewMode);
      if (savedViewMode == null) {
        this.localStorageService.set(this.aircraftLogbookViewMode, this.viewMode);
      } else {
        this.viewMode = savedViewMode;
      }
      this.logbookPagingService.reset();
      this.searchControl.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(filterValue => this.logbookPagingService.setAircraftFilter(filterValue));
      this.aircraftPerPageControl.valueChanges.pipe(filter(val => val != null), takeUntilDestroyed(this.destroyRef)).subscribe(nextValue => this.logbookPagingService.setAircraftPerPage(nextValue));
      this.featuresService.isFeatureActive(FeatureFlyGarmin.AIRCRAFT_LOGBOOK_UPLOAD).subscribe(enabled => this.uploadLogsEnabled = enabled);
    }
    updatePage(pageEvent) {
      this.logbookPagingService.setPage(pageEvent.detail - 1);
    }
    setViewMode(viewMode) {
      this.viewMode = viewMode;
      this.localStorageService.set(this.aircraftLogbookViewMode, this.viewMode);
    }
    static ɵfac = function LogbookAircraftComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LogbookAircraftComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: LogbookAircraftComponent,
      selectors: [["aclogbook-logbook-aircraft"]],
      features: [i0.ɵɵProvidersFeature([AircraftFlightLogCacheService, SupportsAircraftLogbookPipe], [LogbookAircraftPagingService])],
      decls: 3,
      vars: 1,
      consts: [[1, "content"], ["type", "dark", 1, "loader"], [1, "h4-styled-span"], [1, "table-form-controls"], ["label", "Search", "label-for", "logbook-aircraft-search", 1, "table-form-control"], ["id", "logbook-aircraft-search", "type", "text", 3, "formControl"], ["label", "Aircraft Per Page", 1, "table-form-control"], [1, "upload-view-toggles"], [1, "upload-btn"], [1, "view-toggles"], [1, "list-view-button", 3, "click", "ngClass"], ["icon", "list-view", 1, "icon", "size-large"], [1, "card-view-button", 3, "click", "ngClass"], ["icon", "four-square", 1, "icon", "size-large"], [1, "desktop"], [1, "card-container-card"], [1, "card-container-list"], [1, "mobile"], [1, "aircraft-card", 3, "aircraft"], [1, "pagination-details"], [1, "number-aircraft-shown"], [3, "formControl"], [3, "routerLink"], ["ellipses", "true", "firstLastPageButtons", "false", "theme", "light", 3, "g-page-changed", "currentPage", "totalPages"]],
      template: function LogbookAircraftComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, LogbookAircraftComponent_Conditional_1_Template, 4, 0)(2, LogbookAircraftComponent_Conditional_2_Template, 5, 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵconditional(!ctx.logbookPagingService.isLoading() && ctx.logbookPagingService.totalNumberOfAircraft() === 0 ? 1 : 2);
        }
      },
      dependencies: [CommonModule, i1.NgClass, ComponentsGlobalWebModule, i2.GButton, i2.GDropDown, i2.GInput, i2.GLoader, i2.GPagination, MarketingComponent, ReactiveFormsModule, i3.NgSelectOption, i3.ɵNgSelectMultipleOption, i3.DefaultValueAccessor, i3.SelectControlValueAccessor, i3.NgControlStatus, i3.FormControlDirective, LogbookAircraftCardComponent, LogbookAircraftListItemComponent, IconComponent, RouterModule, i2$1.RouterLink],
      styles: [".icon.size-small[_ngcontent-%COMP%]{width:.875rem;height:.875rem}.icon.size-standard[_ngcontent-%COMP%]{width:1.125rem;height:1.125rem}.icon.size-large[_ngcontent-%COMP%]{width:1.75rem;height:1.75rem}.icon.color-black[_ngcontent-%COMP%]{color:#000}.icon.color-red[_ngcontent-%COMP%]{color:#920000}.icon.color-green[_ngcontent-%COMP%]{color:#4bb450}.icon.color-yellow[_ngcontent-%COMP%]{color:#ffaf33}.icon.color-garmin-blue[_ngcontent-%COMP%]{color:#106fad}.icon.color-dark-gray[_ngcontent-%COMP%]{color:#737373}.icon.effect-hover[_ngcontent-%COMP%]{opacity:0;transition:opacity .2s}.icon.effect-hover[_ngcontent-%COMP%]:hover, .icon.effect-hover[_ngcontent-%COMP%]:focus-visible{opacity:1}.icon.prop-clickable[_ngcontent-%COMP%]{cursor:pointer}[_nghost-%COMP%]{margin:0;padding:1rem;display:block}@media screen and (min-width: 768px){[_nghost-%COMP%]{max-width:1200px;margin:0 auto}}.card-container-card[_ngcontent-%COMP%]{display:contents;flex-wrap:wrap;justify-content:center;padding-left:1rem}@media screen and (min-width: 768px){.card-container-card[_ngcontent-%COMP%]{display:grid;grid-template-columns:repeat(auto-fit,minmax(23.5rem,1fr));padding-left:0}}.aircraft-card[_ngcontent-%COMP%]{box-sizing:border-box;margin-bottom:1rem;justify-content:left;margin-right:1rem}.table-form-controls[_ngcontent-%COMP%]   .table-form-control[_ngcontent-%COMP%]{display:inline-block;width:fit-content}.table-form-controls[_ngcontent-%COMP%]   .table-form-control[_ngcontent-%COMP%]:not(:last-child){padding-right:1rem}.table-form-controls[_ngcontent-%COMP%]{margin-bottom:2rem}.table-form-controls[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{background-color:#fff;color:#000;cursor:pointer;transition:background-color .3s,color .3s;border:.1rem solid #000;border-radius:.2rem;padding:.5rem}.table-form-controls[_ngcontent-%COMP%]   button.active[_ngcontent-%COMP%]{background-color:#000;color:#fff}.table-form-controls[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:not(.active){background-color:#fff;color:#000}.table-form-controls[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:first-child{margin-right:.3rem}.number-aircraft-shown[_ngcontent-%COMP%]{font-weight:700}.upload-view-toggles[_ngcontent-%COMP%]{display:inline-block;float:right}.upload-btn[_ngcontent-%COMP%]{display:inline-block;margin-right:1rem;margin-top:2.6rem}.view-toggles[_ngcontent-%COMP%]{margin-top:2.5rem;float:right}.icon.size-large[_ngcontent-%COMP%]{height:1rem;width:1rem}.mobile[_ngcontent-%COMP%]{display:none}.h4-styled-span[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1rem;margin:1rem 0}@media screen and (min-width: 768px){.h4-styled-span[_ngcontent-%COMP%]{font-size:1.25rem}}.pagination-details[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap-reverse;row-gap:.5rem}@media (max-width: 768px){.view-toggles[_ngcontent-%COMP%]{display:none}.mobile[_ngcontent-%COMP%]{display:block}.desktop[_ngcontent-%COMP%]{display:none}}.loader[_ngcontent-%COMP%]{margin:auto}"]
    });
  }
  return LogbookAircraftComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of avcloud-aircraft-logbook
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AIRCRAFT_LOGBOOK_CONFIG, AircraftLogDetailsComponent, AircraftLogbookEntriesComponent, AircraftLogbookUploadFlyAdminComponent, AircraftLogbookUploadFlyGarminComponent, LogbookAircraftComponent };
